
const Icons: { [key: string]: { icon: string, style: string } } = {
    'accessibleIcon': { 'icon': 'accessible-icon', 'style': 'brands' },
    'accusoft': { 'icon': 'accusoft', 'style': 'brands' },
    'addressBook': { 'icon': 'address-book', 'style': 'regular' },
    'solidAddressBook': { 'icon': 'address-book', 'style': 'solid' },
    'addressCard': { 'icon': 'address-card', 'style': 'regular' },
    'solidAddressCard': { 'icon': 'address-card', 'style': 'solid' },
    'adjust': { 'icon': 'adjust', 'style': 'solid' },
    'adn': { 'icon': 'adn', 'style': 'brands' },
    'adversal': { 'icon': 'adversal', 'style': 'brands' },
    'affiliatetheme': { 'icon': 'affiliatetheme', 'style': 'brands' },
    'airFreshener': { 'icon': 'air-freshener', 'style': 'solid' },
    'airbnb': { 'icon': 'airbnb', 'style': 'brands' },
    'algolia': { 'icon': 'algolia', 'style': 'brands' },
    'alignCenter': { 'icon': 'align-center', 'style': 'solid' },
    'alignJustify': { 'icon': 'align-justify', 'style': 'solid' },
    'alignLeft': { 'icon': 'align-left', 'style': 'solid' },
    'alignRight': { 'icon': 'align-right', 'style': 'solid' },
    'alipay': { 'icon': 'alipay', 'style': 'brands' },
    'allergies': { 'icon': 'allergies', 'style': 'solid' },
    'amazon': { 'icon': 'amazon', 'style': 'brands' },
    'amazonPay': { 'icon': 'amazon-pay', 'style': 'brands' },
    'ambulance': { 'icon': 'ambulance', 'style': 'solid' },
    'amilia': { 'icon': 'amilia', 'style': 'brands' },
    'anchor': { 'icon': 'anchor', 'style': 'solid' },
    'android': { 'icon': 'android', 'style': 'brands' },
    'angellist': { 'icon': 'angellist', 'style': 'brands' },
    'angleDoubleDown': { 'icon': 'angle-double-down', 'style': 'solid' },
    'angleDoubleLeft': { 'icon': 'angle-double-left', 'style': 'solid' },
    'angleDoubleRight': { 'icon': 'angle-double-right', 'style': 'solid' },
    'angleDoubleUp': { 'icon': 'angle-double-up', 'style': 'solid' },
    'angleDown': { 'icon': 'angle-down', 'style': 'solid' },
    'angleLeft': { 'icon': 'angle-left', 'style': 'solid' },
    'angleRight': { 'icon': 'angle-right', 'style': 'solid' },
    'angleUp': { 'icon': 'angle-up', 'style': 'solid' },
    'angry': { 'icon': 'angry', 'style': 'regular' },
    'solidAngry': { 'icon': 'angry', 'style': 'solid' },
    'angrycreative': { 'icon': 'angrycreative', 'style': 'brands' },
    'angular': { 'icon': 'angular', 'style': 'brands' },
    'ankh': { 'icon': 'ankh', 'style': 'solid' },
    'appStore': { 'icon': 'app-store', 'style': 'brands' },
    'appStoreIos': { 'icon': 'app-store-ios', 'style': 'brands' },
    'apper': { 'icon': 'apper', 'style': 'brands' },
    'apple': { 'icon': 'apple', 'style': 'brands' },
    'appleAlt': { 'icon': 'apple-alt', 'style': 'solid' },
    'applePay': { 'icon': 'apple-pay', 'style': 'brands' },
    'archive': { 'icon': 'archive', 'style': 'solid' },
    'archway': { 'icon': 'archway', 'style': 'solid' },
    'arrowAltCircleDown': { 'icon': 'arrow-alt-circle-down', 'style': 'regular' },
    'solidArrowAltCircleDown': { 'icon': 'arrow-alt-circle-down', 'style': 'solid' },
    'arrowAltCircleLeft': { 'icon': 'arrow-alt-circle-left', 'style': 'regular' },
    'solidArrowAltCircleLeft': { 'icon': 'arrow-alt-circle-left', 'style': 'solid' },
    'arrowAltCircleRight': { 'icon': 'arrow-alt-circle-right', 'style': 'regular' },
    'solidArrowAltCircleRight': { 'icon': 'arrow-alt-circle-right', 'style': 'solid' },
    'arrowAltCircleUp': { 'icon': 'arrow-alt-circle-up', 'style': 'regular' },
    'solidArrowAltCircleUp': { 'icon': 'arrow-alt-circle-up', 'style': 'solid' },
    'arrowCircleDown': { 'icon': 'arrow-circle-down', 'style': 'solid' },
    'arrowCircleLeft': { 'icon': 'arrow-circle-left', 'style': 'solid' },
    'arrowCircleRight': { 'icon': 'arrow-circle-right', 'style': 'solid' },
    'arrowCircleUp': { 'icon': 'arrow-circle-up', 'style': 'solid' },
    'arrowDown': { 'icon': 'arrow-down', 'style': 'solid' },
    'arrowLeft': { 'icon': 'arrow-left', 'style': 'solid' },
    'arrowRight': { 'icon': 'arrow-right', 'style': 'solid' },
    'arrowUp': { 'icon': 'arrow-up', 'style': 'solid' },
    'arrowsAlt': { 'icon': 'arrows-alt', 'style': 'solid' },
    'arrowsAltH': { 'icon': 'arrows-alt-h', 'style': 'solid' },
    'arrowsAltV': { 'icon': 'arrows-alt-v', 'style': 'solid' },
    'artstation': { 'icon': 'artstation', 'style': 'brands' },
    'assistiveListeningSystems': { 'icon': 'assistive-listening-systems', 'style': 'solid' },
    'asterisk': { 'icon': 'asterisk', 'style': 'solid' },
    'asymmetrik': { 'icon': 'asymmetrik', 'style': 'brands' },
    'atlas': { 'icon': 'atlas', 'style': 'solid' },
    'atlassian': { 'icon': 'atlassian', 'style': 'brands' },
    'atom': { 'icon': 'atom', 'style': 'solid' },
    'audible': { 'icon': 'audible', 'style': 'brands' },
    'audioDescription': { 'icon': 'audio-description', 'style': 'solid' },
    'autoprefixer': { 'icon': 'autoprefixer', 'style': 'brands' },
    'avianex': { 'icon': 'avianex', 'style': 'brands' },
    'aviato': { 'icon': 'aviato', 'style': 'brands' },
    'award': { 'icon': 'award', 'style': 'solid' },
    'aws': { 'icon': 'aws', 'style': 'brands' },
    'baby': { 'icon': 'baby', 'style': 'solid' },
    'babyCarriage': { 'icon': 'baby-carriage', 'style': 'solid' },
    'backspace': { 'icon': 'backspace', 'style': 'solid' },
    'backward': { 'icon': 'backward', 'style': 'solid' },
    'bacon': { 'icon': 'bacon', 'style': 'solid' },
    'bacteria': { 'icon': 'bacteria', 'style': 'solid' },
    'bacterium': { 'icon': 'bacterium', 'style': 'solid' },
    'bahai': { 'icon': 'bahai', 'style': 'solid' },
    'balanceScale': { 'icon': 'balance-scale', 'style': 'solid' },
    'balanceScaleLeft': { 'icon': 'balance-scale-left', 'style': 'solid' },
    'balanceScaleRight': { 'icon': 'balance-scale-right', 'style': 'solid' },
    'ban': { 'icon': 'ban', 'style': 'solid' },
    'bandAid': { 'icon': 'band-aid', 'style': 'solid' },
    'bandcamp': { 'icon': 'bandcamp', 'style': 'brands' },
    'barcode': { 'icon': 'barcode', 'style': 'solid' },
    'bars': { 'icon': 'bars', 'style': 'solid' },
    'baseballBall': { 'icon': 'baseball-ball', 'style': 'solid' },
    'basketballBall': { 'icon': 'basketball-ball', 'style': 'solid' },
    'bath': { 'icon': 'bath', 'style': 'solid' },
    'batteryEmpty': { 'icon': 'battery-empty', 'style': 'solid' },
    'batteryFull': { 'icon': 'battery-full', 'style': 'solid' },
    'batteryHalf': { 'icon': 'battery-half', 'style': 'solid' },
    'batteryQuarter': { 'icon': 'battery-quarter', 'style': 'solid' },
    'batteryThreeQuarters': { 'icon': 'battery-three-quarters', 'style': 'solid' },
    'battleNet': { 'icon': 'battle-net', 'style': 'brands' },
    'bed': { 'icon': 'bed', 'style': 'solid' },
    'beer': { 'icon': 'beer', 'style': 'solid' },
    'behance': { 'icon': 'behance', 'style': 'brands' },
    'behanceSquare': { 'icon': 'behance-square', 'style': 'brands' },
    'bell': { 'icon': 'bell', 'style': 'regular' },
    'solidBell': { 'icon': 'bell', 'style': 'solid' },
    'bellSlash': { 'icon': 'bell-slash', 'style': 'regular' },
    'solidBellSlash': { 'icon': 'bell-slash', 'style': 'solid' },
    'bezierCurve': { 'icon': 'bezier-curve', 'style': 'solid' },
    'bible': { 'icon': 'bible', 'style': 'solid' },
    'bicycle': { 'icon': 'bicycle', 'style': 'solid' },
    'biking': { 'icon': 'biking', 'style': 'solid' },
    'bimobject': { 'icon': 'bimobject', 'style': 'brands' },
    'binoculars': { 'icon': 'binoculars', 'style': 'solid' },
    'biohazard': { 'icon': 'biohazard', 'style': 'solid' },
    'birthdayCake': { 'icon': 'birthday-cake', 'style': 'solid' },
    'bitbucket': { 'icon': 'bitbucket', 'style': 'brands' },
    'bitcoin': { 'icon': 'bitcoin', 'style': 'brands' },
    'bity': { 'icon': 'bity', 'style': 'brands' },
    'blackTie': { 'icon': 'black-tie', 'style': 'brands' },
    'blackberry': { 'icon': 'blackberry', 'style': 'brands' },
    'blender': { 'icon': 'blender', 'style': 'solid' },
    'blenderPhone': { 'icon': 'blender-phone', 'style': 'solid' },
    'blind': { 'icon': 'blind', 'style': 'solid' },
    'blog': { 'icon': 'blog', 'style': 'solid' },
    'blogger': { 'icon': 'blogger', 'style': 'brands' },
    'bloggerB': { 'icon': 'blogger-b', 'style': 'brands' },
    'bluetooth': { 'icon': 'bluetooth', 'style': 'brands' },
    'bluetoothB': { 'icon': 'bluetooth-b', 'style': 'brands' },
    'bold': { 'icon': 'bold', 'style': 'solid' },
    'bolt': { 'icon': 'bolt', 'style': 'solid' },
    'bomb': { 'icon': 'bomb', 'style': 'solid' },
    'bone': { 'icon': 'bone', 'style': 'solid' },
    'bong': { 'icon': 'bong', 'style': 'solid' },
    'book': { 'icon': 'book', 'style': 'solid' },
    'bookDead': { 'icon': 'book-dead', 'style': 'solid' },
    'bookMedical': { 'icon': 'book-medical', 'style': 'solid' },
    'bookOpen': { 'icon': 'book-open', 'style': 'solid' },
    'bookReader': { 'icon': 'book-reader', 'style': 'solid' },
    'bookmark': { 'icon': 'bookmark', 'style': 'regular' },
    'solidBookmark': { 'icon': 'bookmark', 'style': 'solid' },
    'bootstrap': { 'icon': 'bootstrap', 'style': 'brands' },
    'borderAll': { 'icon': 'border-all', 'style': 'solid' },
    'borderNone': { 'icon': 'border-none', 'style': 'solid' },
    'borderStyle': { 'icon': 'border-style', 'style': 'solid' },
    'bowlingBall': { 'icon': 'bowling-ball', 'style': 'solid' },
    'box': { 'icon': 'box', 'style': 'solid' },
    'boxOpen': { 'icon': 'box-open', 'style': 'solid' },
    'boxTissue': { 'icon': 'box-tissue', 'style': 'solid' },
    'boxes': { 'icon': 'boxes', 'style': 'solid' },
    'braille': { 'icon': 'braille', 'style': 'solid' },
    'brain': { 'icon': 'brain', 'style': 'solid' },
    'breadSlice': { 'icon': 'bread-slice', 'style': 'solid' },
    'briefcase': { 'icon': 'briefcase', 'style': 'solid' },
    'briefcaseMedical': { 'icon': 'briefcase-medical', 'style': 'solid' },
    'broadcastTower': { 'icon': 'broadcast-tower', 'style': 'solid' },
    'broom': { 'icon': 'broom', 'style': 'solid' },
    'brush': { 'icon': 'brush', 'style': 'solid' },
    'btc': { 'icon': 'btc', 'style': 'brands' },
    'buffer': { 'icon': 'buffer', 'style': 'brands' },
    'bug': { 'icon': 'bug', 'style': 'solid' },
    'building': { 'icon': 'building', 'style': 'regular' },
    'solidBuilding': { 'icon': 'building', 'style': 'solid' },
    'bullhorn': { 'icon': 'bullhorn', 'style': 'solid' },
    'bullseye': { 'icon': 'bullseye', 'style': 'solid' },
    'burn': { 'icon': 'burn', 'style': 'solid' },
    'buromobelexperte': { 'icon': 'buromobelexperte', 'style': 'brands' },
    'bus': { 'icon': 'bus', 'style': 'solid' },
    'busAlt': { 'icon': 'bus-alt', 'style': 'solid' },
    'businessTime': { 'icon': 'business-time', 'style': 'solid' },
    'buyNLarge': { 'icon': 'buy-n-large', 'style': 'brands' },
    'buysellads': { 'icon': 'buysellads', 'style': 'brands' },
    'calculator': { 'icon': 'calculator', 'style': 'solid' },
    'calendar': { 'icon': 'calendar', 'style': 'regular' },
    'solidCalendar': { 'icon': 'calendar', 'style': 'solid' },
    'calendarAlt': { 'icon': 'calendar-alt', 'style': 'regular' },
    'solidCalendarAlt': { 'icon': 'calendar-alt', 'style': 'solid' },
    'calendarCheck': { 'icon': 'calendar-check', 'style': 'regular' },
    'solidCalendarCheck': { 'icon': 'calendar-check', 'style': 'solid' },
    'calendarDay': { 'icon': 'calendar-day', 'style': 'solid' },
    'calendarMinus': { 'icon': 'calendar-minus', 'style': 'regular' },
    'solidCalendarMinus': { 'icon': 'calendar-minus', 'style': 'solid' },
    'calendarPlus': { 'icon': 'calendar-plus', 'style': 'regular' },
    'solidCalendarPlus': { 'icon': 'calendar-plus', 'style': 'solid' },
    'calendarTimes': { 'icon': 'calendar-times', 'style': 'regular' },
    'solidCalendarTimes': { 'icon': 'calendar-times', 'style': 'solid' },
    'calendarWeek': { 'icon': 'calendar-week', 'style': 'solid' },
    'camera': { 'icon': 'camera', 'style': 'solid' },
    'cameraRetro': { 'icon': 'camera-retro', 'style': 'solid' },
    'campground': { 'icon': 'campground', 'style': 'solid' },
    'canadianMapleLeaf': { 'icon': 'canadian-maple-leaf', 'style': 'brands' },
    'candyCane': { 'icon': 'candy-cane', 'style': 'solid' },
    'cannabis': { 'icon': 'cannabis', 'style': 'solid' },
    'capsules': { 'icon': 'capsules', 'style': 'solid' },
    'car': { 'icon': 'car', 'style': 'solid' },
    'carAlt': { 'icon': 'car-alt', 'style': 'solid' },
    'carBattery': { 'icon': 'car-battery', 'style': 'solid' },
    'carCrash': { 'icon': 'car-crash', 'style': 'solid' },
    'carSide': { 'icon': 'car-side', 'style': 'solid' },
    'caravan': { 'icon': 'caravan', 'style': 'solid' },
    'caretDown': { 'icon': 'caret-down', 'style': 'solid' },
    'caretLeft': { 'icon': 'caret-left', 'style': 'solid' },
    'caretRight': { 'icon': 'caret-right', 'style': 'solid' },
    'caretSquareDown': { 'icon': 'caret-square-down', 'style': 'regular' },
    'solidCaretSquareDown': { 'icon': 'caret-square-down', 'style': 'solid' },
    'caretSquareLeft': { 'icon': 'caret-square-left', 'style': 'regular' },
    'solidCaretSquareLeft': { 'icon': 'caret-square-left', 'style': 'solid' },
    'caretSquareRight': { 'icon': 'caret-square-right', 'style': 'regular' },
    'solidCaretSquareRight': { 'icon': 'caret-square-right', 'style': 'solid' },
    'caretSquareUp': { 'icon': 'caret-square-up', 'style': 'regular' },
    'solidCaretSquareUp': { 'icon': 'caret-square-up', 'style': 'solid' },
    'caretUp': { 'icon': 'caret-up', 'style': 'solid' },
    'carrot': { 'icon': 'carrot', 'style': 'solid' },
    'cartArrowDown': { 'icon': 'cart-arrow-down', 'style': 'solid' },
    'cartPlus': { 'icon': 'cart-plus', 'style': 'solid' },
    'cashRegister': { 'icon': 'cash-register', 'style': 'solid' },
    'cat': { 'icon': 'cat', 'style': 'solid' },
    'ccAmazonPay': { 'icon': 'cc-amazon-pay', 'style': 'brands' },
    'ccAmex': { 'icon': 'cc-amex', 'style': 'brands' },
    'ccApplePay': { 'icon': 'cc-apple-pay', 'style': 'brands' },
    'ccDinersClub': { 'icon': 'cc-diners-club', 'style': 'brands' },
    'ccDiscover': { 'icon': 'cc-discover', 'style': 'brands' },
    'ccJcb': { 'icon': 'cc-jcb', 'style': 'brands' },
    'ccMastercard': { 'icon': 'cc-mastercard', 'style': 'brands' },
    'ccPaypal': { 'icon': 'cc-paypal', 'style': 'brands' },
    'ccStripe': { 'icon': 'cc-stripe', 'style': 'brands' },
    'ccVisa': { 'icon': 'cc-visa', 'style': 'brands' },
    'centercode': { 'icon': 'centercode', 'style': 'brands' },
    'centos': { 'icon': 'centos', 'style': 'brands' },
    'certificate': { 'icon': 'certificate', 'style': 'solid' },
    'chair': { 'icon': 'chair', 'style': 'solid' },
    'chalkboard': { 'icon': 'chalkboard', 'style': 'solid' },
    'chalkboardTeacher': { 'icon': 'chalkboard-teacher', 'style': 'solid' },
    'chargingStation': { 'icon': 'charging-station', 'style': 'solid' },
    'chartArea': { 'icon': 'chart-area', 'style': 'solid' },
    'chartBar': { 'icon': 'chart-bar', 'style': 'regular' },
    'solidChartBar': { 'icon': 'chart-bar', 'style': 'solid' },
    'chartLine': { 'icon': 'chart-line', 'style': 'solid' },
    'chartPie': { 'icon': 'chart-pie', 'style': 'solid' },
    'check': { 'icon': 'check', 'style': 'solid' },
    'checkCircle': { 'icon': 'check-circle', 'style': 'regular' },
    'solidCheckCircle': { 'icon': 'check-circle', 'style': 'solid' },
    'checkDouble': { 'icon': 'check-double', 'style': 'solid' },
    'checkSquare': { 'icon': 'check-square', 'style': 'regular' },
    'solidCheckSquare': { 'icon': 'check-square', 'style': 'solid' },
    'cheese': { 'icon': 'cheese', 'style': 'solid' },
    'chess': { 'icon': 'chess', 'style': 'solid' },
    'chessBishop': { 'icon': 'chess-bishop', 'style': 'solid' },
    'chessBoard': { 'icon': 'chess-board', 'style': 'solid' },
    'chessKing': { 'icon': 'chess-king', 'style': 'solid' },
    'chessKnight': { 'icon': 'chess-knight', 'style': 'solid' },
    'chessPawn': { 'icon': 'chess-pawn', 'style': 'solid' },
    'chessQueen': { 'icon': 'chess-queen', 'style': 'solid' },
    'chessRook': { 'icon': 'chess-rook', 'style': 'solid' },
    'chevronCircleDown': { 'icon': 'chevron-circle-down', 'style': 'solid' },
    'chevronCircleLeft': { 'icon': 'chevron-circle-left', 'style': 'solid' },
    'chevronCircleRight': { 'icon': 'chevron-circle-right', 'style': 'solid' },
    'chevronCircleUp': { 'icon': 'chevron-circle-up', 'style': 'solid' },
    'chevronDown': { 'icon': 'chevron-down', 'style': 'solid' },
    'chevronLeft': { 'icon': 'chevron-left', 'style': 'solid' },
    'chevronRight': { 'icon': 'chevron-right', 'style': 'solid' },
    'chevronUp': { 'icon': 'chevron-up', 'style': 'solid' },
    'child': { 'icon': 'child', 'style': 'solid' },
    'chrome': { 'icon': 'chrome', 'style': 'brands' },
    'chromecast': { 'icon': 'chromecast', 'style': 'brands' },
    'church': { 'icon': 'church', 'style': 'solid' },
    'circle': { 'icon': 'circle', 'style': 'regular' },
    'solidCircle': { 'icon': 'circle', 'style': 'solid' },
    'circleNotch': { 'icon': 'circle-notch', 'style': 'solid' },
    'city': { 'icon': 'city', 'style': 'solid' },
    'clinicMedical': { 'icon': 'clinic-medical', 'style': 'solid' },
    'clipboard': { 'icon': 'clipboard', 'style': 'regular' },
    'solidClipboard': { 'icon': 'clipboard', 'style': 'solid' },
    'clipboardCheck': { 'icon': 'clipboard-check', 'style': 'solid' },
    'clipboardList': { 'icon': 'clipboard-list', 'style': 'solid' },
    'clock': { 'icon': 'clock', 'style': 'regular' },
    'solidClock': { 'icon': 'clock', 'style': 'solid' },
    'clone': { 'icon': 'clone', 'style': 'regular' },
    'solidClone': { 'icon': 'clone', 'style': 'solid' },
    'closedCaptioning': { 'icon': 'closed-captioning', 'style': 'regular' },
    'solidClosedCaptioning': { 'icon': 'closed-captioning', 'style': 'solid' },
    'cloud': { 'icon': 'cloud', 'style': 'solid' },
    'cloudDownloadAlt': { 'icon': 'cloud-download-alt', 'style': 'solid' },
    'cloudMeatball': { 'icon': 'cloud-meatball', 'style': 'solid' },
    'cloudMoon': { 'icon': 'cloud-moon', 'style': 'solid' },
    'cloudMoonRain': { 'icon': 'cloud-moon-rain', 'style': 'solid' },
    'cloudRain': { 'icon': 'cloud-rain', 'style': 'solid' },
    'cloudShowersHeavy': { 'icon': 'cloud-showers-heavy', 'style': 'solid' },
    'cloudSun': { 'icon': 'cloud-sun', 'style': 'solid' },
    'cloudSunRain': { 'icon': 'cloud-sun-rain', 'style': 'solid' },
    'cloudUploadAlt': { 'icon': 'cloud-upload-alt', 'style': 'solid' },
    'cloudflare': { 'icon': 'cloudflare', 'style': 'brands' },
    'cloudscale': { 'icon': 'cloudscale', 'style': 'brands' },
    'cloudsmith': { 'icon': 'cloudsmith', 'style': 'brands' },
    'cloudversify': { 'icon': 'cloudversify', 'style': 'brands' },
    'cocktail': { 'icon': 'cocktail', 'style': 'solid' },
    'code': { 'icon': 'code', 'style': 'solid' },
    'codeBranch': { 'icon': 'code-branch', 'style': 'solid' },
    'codepen': { 'icon': 'codepen', 'style': 'brands' },
    'codiepie': { 'icon': 'codiepie', 'style': 'brands' },
    'coffee': { 'icon': 'coffee', 'style': 'solid' },
    'cog': { 'icon': 'cog', 'style': 'solid' },
    'cogs': { 'icon': 'cogs', 'style': 'solid' },
    'coins': { 'icon': 'coins', 'style': 'solid' },
    'columns': { 'icon': 'columns', 'style': 'solid' },
    'comment': { 'icon': 'comment', 'style': 'regular' },
    'solidComment': { 'icon': 'comment', 'style': 'solid' },
    'commentAlt': { 'icon': 'comment-alt', 'style': 'regular' },
    'solidCommentAlt': { 'icon': 'comment-alt', 'style': 'solid' },
    'commentDollar': { 'icon': 'comment-dollar', 'style': 'solid' },
    'commentDots': { 'icon': 'comment-dots', 'style': 'regular' },
    'solidCommentDots': { 'icon': 'comment-dots', 'style': 'solid' },
    'commentMedical': { 'icon': 'comment-medical', 'style': 'solid' },
    'commentSlash': { 'icon': 'comment-slash', 'style': 'solid' },
    'comments': { 'icon': 'comments', 'style': 'regular' },
    'solidComments': { 'icon': 'comments', 'style': 'solid' },
    'commentsDollar': { 'icon': 'comments-dollar', 'style': 'solid' },
    'compactDisc': { 'icon': 'compact-disc', 'style': 'solid' },
    'compass': { 'icon': 'compass', 'style': 'regular' },
    'solidCompass': { 'icon': 'compass', 'style': 'solid' },
    'compress': { 'icon': 'compress', 'style': 'solid' },
    'compressAlt': { 'icon': 'compress-alt', 'style': 'solid' },
    'compressArrowsAlt': { 'icon': 'compress-arrows-alt', 'style': 'solid' },
    'conciergeBell': { 'icon': 'concierge-bell', 'style': 'solid' },
    'confluence': { 'icon': 'confluence', 'style': 'brands' },
    'connectdevelop': { 'icon': 'connectdevelop', 'style': 'brands' },
    'contao': { 'icon': 'contao', 'style': 'brands' },
    'cookie': { 'icon': 'cookie', 'style': 'solid' },
    'cookieBite': { 'icon': 'cookie-bite', 'style': 'solid' },
    'copy': { 'icon': 'copy', 'style': 'regular' },
    'solidCopy': { 'icon': 'copy', 'style': 'solid' },
    'copyright': { 'icon': 'copyright', 'style': 'regular' },
    'solidCopyright': { 'icon': 'copyright', 'style': 'solid' },
    'cottonBureau': { 'icon': 'cotton-bureau', 'style': 'brands' },
    'couch': { 'icon': 'couch', 'style': 'solid' },
    'cpanel': { 'icon': 'cpanel', 'style': 'brands' },
    'creativeCommons': { 'icon': 'creative-commons', 'style': 'brands' },
    'creativeCommonsBy': { 'icon': 'creative-commons-by', 'style': 'brands' },
    'creativeCommonsNc': { 'icon': 'creative-commons-nc', 'style': 'brands' },
    'creativeCommonsNcEu': { 'icon': 'creative-commons-nc-eu', 'style': 'brands' },
    'creativeCommonsNcJp': { 'icon': 'creative-commons-nc-jp', 'style': 'brands' },
    'creativeCommonsNd': { 'icon': 'creative-commons-nd', 'style': 'brands' },
    'creativeCommonsPd': { 'icon': 'creative-commons-pd', 'style': 'brands' },
    'creativeCommonsPdAlt': { 'icon': 'creative-commons-pd-alt', 'style': 'brands' },
    'creativeCommonsRemix': { 'icon': 'creative-commons-remix', 'style': 'brands' },
    'creativeCommonsSa': { 'icon': 'creative-commons-sa', 'style': 'brands' },
    'creativeCommonsSampling': { 'icon': 'creative-commons-sampling', 'style': 'brands' },
    'creativeCommonsShare': { 'icon': 'creative-commons-share', 'style': 'brands' },
    'creativeCommonsZero': { 'icon': 'creative-commons-zero', 'style': 'brands' },
    'creditCard': { 'icon': 'credit-card', 'style': 'regular' },
    'solidCreditCard': { 'icon': 'credit-card', 'style': 'solid' },
    'criticalRole': { 'icon': 'critical-role', 'style': 'brands' },
    'crop': { 'icon': 'crop', 'style': 'solid' },
    'cropAlt': { 'icon': 'crop-alt', 'style': 'solid' },
    'cross': { 'icon': 'cross', 'style': 'solid' },
    'crosshairs': { 'icon': 'crosshairs', 'style': 'solid' },
    'crow': { 'icon': 'crow', 'style': 'solid' },
    'crown': { 'icon': 'crown', 'style': 'solid' },
    'crutch': { 'icon': 'crutch', 'style': 'solid' },
    'css3': { 'icon': 'css3', 'style': 'brands' },
    'css3Alt': { 'icon': 'css3-alt', 'style': 'brands' },
    'cube': { 'icon': 'cube', 'style': 'solid' },
    'cubes': { 'icon': 'cubes', 'style': 'solid' },
    'cut': { 'icon': 'cut', 'style': 'solid' },
    'cuttlefish': { 'icon': 'cuttlefish', 'style': 'brands' },
    'dAndD': { 'icon': 'd-and-d', 'style': 'brands' },
    'dAndDBeyond': { 'icon': 'd-and-d-beyond', 'style': 'brands' },
    'dailymotion': { 'icon': 'dailymotion', 'style': 'brands' },
    'dashcube': { 'icon': 'dashcube', 'style': 'brands' },
    'database': { 'icon': 'database', 'style': 'solid' },
    'deaf': { 'icon': 'deaf', 'style': 'solid' },
    'deezer': { 'icon': 'deezer', 'style': 'brands' },
    'delicious': { 'icon': 'delicious', 'style': 'brands' },
    'democrat': { 'icon': 'democrat', 'style': 'solid' },
    'deploydog': { 'icon': 'deploydog', 'style': 'brands' },
    'deskpro': { 'icon': 'deskpro', 'style': 'brands' },
    'desktop': { 'icon': 'desktop', 'style': 'solid' },
    'dev': { 'icon': 'dev', 'style': 'brands' },
    'deviantart': { 'icon': 'deviantart', 'style': 'brands' },
    'dharmachakra': { 'icon': 'dharmachakra', 'style': 'solid' },
    'dhl': { 'icon': 'dhl', 'style': 'brands' },
    'diagnoses': { 'icon': 'diagnoses', 'style': 'solid' },
    'diaspora': { 'icon': 'diaspora', 'style': 'brands' },
    'dice': { 'icon': 'dice', 'style': 'solid' },
    'diceD20': { 'icon': 'dice-d20', 'style': 'solid' },
    'diceD6': { 'icon': 'dice-d6', 'style': 'solid' },
    'diceFive': { 'icon': 'dice-five', 'style': 'solid' },
    'diceFour': { 'icon': 'dice-four', 'style': 'solid' },
    'diceOne': { 'icon': 'dice-one', 'style': 'solid' },
    'diceSix': { 'icon': 'dice-six', 'style': 'solid' },
    'diceThree': { 'icon': 'dice-three', 'style': 'solid' },
    'diceTwo': { 'icon': 'dice-two', 'style': 'solid' },
    'digg': { 'icon': 'digg', 'style': 'brands' },
    'digitalOcean': { 'icon': 'digital-ocean', 'style': 'brands' },
    'digitalTachograph': { 'icon': 'digital-tachograph', 'style': 'solid' },
    'directions': { 'icon': 'directions', 'style': 'solid' },
    'discord': { 'icon': 'discord', 'style': 'brands' },
    'discourse': { 'icon': 'discourse', 'style': 'brands' },
    'disease': { 'icon': 'disease', 'style': 'solid' },
    'divide': { 'icon': 'divide', 'style': 'solid' },
    'dizzy': { 'icon': 'dizzy', 'style': 'regular' },
    'solidDizzy': { 'icon': 'dizzy', 'style': 'solid' },
    'dna': { 'icon': 'dna', 'style': 'solid' },
    'dochub': { 'icon': 'dochub', 'style': 'brands' },
    'docker': { 'icon': 'docker', 'style': 'brands' },
    'dog': { 'icon': 'dog', 'style': 'solid' },
    'dollarSign': { 'icon': 'dollar-sign', 'style': 'solid' },
    'dolly': { 'icon': 'dolly', 'style': 'solid' },
    'dollyFlatbed': { 'icon': 'dolly-flatbed', 'style': 'solid' },
    'donate': { 'icon': 'donate', 'style': 'solid' },
    'doorClosed': { 'icon': 'door-closed', 'style': 'solid' },
    'doorOpen': { 'icon': 'door-open', 'style': 'solid' },
    'dotCircle': { 'icon': 'dot-circle', 'style': 'regular' },
    'solidDotCircle': { 'icon': 'dot-circle', 'style': 'solid' },
    'dove': { 'icon': 'dove', 'style': 'solid' },
    'download': { 'icon': 'download', 'style': 'solid' },
    'draft2digital': { 'icon': 'draft2digital', 'style': 'brands' },
    'draftingCompass': { 'icon': 'drafting-compass', 'style': 'solid' },
    'dragon': { 'icon': 'dragon', 'style': 'solid' },
    'drawPolygon': { 'icon': 'draw-polygon', 'style': 'solid' },
    'dribbble': { 'icon': 'dribbble', 'style': 'brands' },
    'dribbbleSquare': { 'icon': 'dribbble-square', 'style': 'brands' },
    'dropbox': { 'icon': 'dropbox', 'style': 'brands' },
    'drum': { 'icon': 'drum', 'style': 'solid' },
    'drumSteelpan': { 'icon': 'drum-steelpan', 'style': 'solid' },
    'drumstickBite': { 'icon': 'drumstick-bite', 'style': 'solid' },
    'drupal': { 'icon': 'drupal', 'style': 'brands' },
    'dumbbell': { 'icon': 'dumbbell', 'style': 'solid' },
    'dumpster': { 'icon': 'dumpster', 'style': 'solid' },
    'dumpsterFire': { 'icon': 'dumpster-fire', 'style': 'solid' },
    'dungeon': { 'icon': 'dungeon', 'style': 'solid' },
    'dyalog': { 'icon': 'dyalog', 'style': 'brands' },
    'earlybirds': { 'icon': 'earlybirds', 'style': 'brands' },
    'ebay': { 'icon': 'ebay', 'style': 'brands' },
    'edge': { 'icon': 'edge', 'style': 'brands' },
    'edgeLegacy': { 'icon': 'edge-legacy', 'style': 'brands' },
    'edit': { 'icon': 'edit', 'style': 'regular' },
    'solidEdit': { 'icon': 'edit', 'style': 'solid' },
    'egg': { 'icon': 'egg', 'style': 'solid' },
    'eject': { 'icon': 'eject', 'style': 'solid' },
    'elementor': { 'icon': 'elementor', 'style': 'brands' },
    'ellipsisH': { 'icon': 'ellipsis-h', 'style': 'solid' },
    'ellipsisV': { 'icon': 'ellipsis-v', 'style': 'solid' },
    'ello': { 'icon': 'ello', 'style': 'brands' },
    'ember': { 'icon': 'ember', 'style': 'brands' },
    'empire': { 'icon': 'empire', 'style': 'brands' },
    'envelope': { 'icon': 'envelope', 'style': 'regular' },
    'solidEnvelope': { 'icon': 'envelope', 'style': 'solid' },
    'envelopeOpen': { 'icon': 'envelope-open', 'style': 'regular' },
    'solidEnvelopeOpen': { 'icon': 'envelope-open', 'style': 'solid' },
    'envelopeOpenText': { 'icon': 'envelope-open-text', 'style': 'solid' },
    'envelopeSquare': { 'icon': 'envelope-square', 'style': 'solid' },
    'envira': { 'icon': 'envira', 'style': 'brands' },
    'equals': { 'icon': 'equals', 'style': 'solid' },
    'eraser': { 'icon': 'eraser', 'style': 'solid' },
    'erlang': { 'icon': 'erlang', 'style': 'brands' },
    'ethereum': { 'icon': 'ethereum', 'style': 'brands' },
    'ethernet': { 'icon': 'ethernet', 'style': 'solid' },
    'etsy': { 'icon': 'etsy', 'style': 'brands' },
    'euroSign': { 'icon': 'euro-sign', 'style': 'solid' },
    'evernote': { 'icon': 'evernote', 'style': 'brands' },
    'exchangeAlt': { 'icon': 'exchange-alt', 'style': 'solid' },
    'exclamation': { 'icon': 'exclamation', 'style': 'solid' },
    'exclamationCircle': { 'icon': 'exclamation-circle', 'style': 'solid' },
    'exclamationTriangle': { 'icon': 'exclamation-triangle', 'style': 'solid' },
    'expand': { 'icon': 'expand', 'style': 'solid' },
    'expandAlt': { 'icon': 'expand-alt', 'style': 'solid' },
    'expandArrowsAlt': { 'icon': 'expand-arrows-alt', 'style': 'solid' },
    'expeditedssl': { 'icon': 'expeditedssl', 'style': 'brands' },
    'externalLinkAlt': { 'icon': 'external-link-alt', 'style': 'solid' },
    'externalLinkSquareAlt': { 'icon': 'external-link-square-alt', 'style': 'solid' },
    'eye': { 'icon': 'eye', 'style': 'regular' },
    'solidEye': { 'icon': 'eye', 'style': 'solid' },
    'eyeDropper': { 'icon': 'eye-dropper', 'style': 'solid' },
    'eyeSlash': { 'icon': 'eye-slash', 'style': 'regular' },
    'solidEyeSlash': { 'icon': 'eye-slash', 'style': 'solid' },
    'facebook': { 'icon': 'facebook', 'style': 'brands' },
    'facebookF': { 'icon': 'facebook-f', 'style': 'brands' },
    'facebookMessenger': { 'icon': 'facebook-messenger', 'style': 'brands' },
    'facebookSquare': { 'icon': 'facebook-square', 'style': 'brands' },
    'fan': { 'icon': 'fan', 'style': 'solid' },
    'fantasyFlightGames': { 'icon': 'fantasy-flight-games', 'style': 'brands' },
    'fastBackward': { 'icon': 'fast-backward', 'style': 'solid' },
    'fastForward': { 'icon': 'fast-forward', 'style': 'solid' },
    'faucet': { 'icon': 'faucet', 'style': 'solid' },
    'fax': { 'icon': 'fax', 'style': 'solid' },
    'feather': { 'icon': 'feather', 'style': 'solid' },
    'featherAlt': { 'icon': 'feather-alt', 'style': 'solid' },
    'fedex': { 'icon': 'fedex', 'style': 'brands' },
    'fedora': { 'icon': 'fedora', 'style': 'brands' },
    'female': { 'icon': 'female', 'style': 'solid' },
    'fighterJet': { 'icon': 'fighter-jet', 'style': 'solid' },
    'figma': { 'icon': 'figma', 'style': 'brands' },
    'file': { 'icon': 'file', 'style': 'regular' },
    'solidFile': { 'icon': 'file', 'style': 'solid' },
    'fileAlt': { 'icon': 'file-alt', 'style': 'regular' },
    'solidFileAlt': { 'icon': 'file-alt', 'style': 'solid' },
    'fileArchive': { 'icon': 'file-archive', 'style': 'regular' },
    'solidFileArchive': { 'icon': 'file-archive', 'style': 'solid' },
    'fileAudio': { 'icon': 'file-audio', 'style': 'regular' },
    'solidFileAudio': { 'icon': 'file-audio', 'style': 'solid' },
    'fileCode': { 'icon': 'file-code', 'style': 'regular' },
    'solidFileCode': { 'icon': 'file-code', 'style': 'solid' },
    'fileContract': { 'icon': 'file-contract', 'style': 'solid' },
    'fileCsv': { 'icon': 'file-csv', 'style': 'solid' },
    'fileDownload': { 'icon': 'file-download', 'style': 'solid' },
    'fileExcel': { 'icon': 'file-excel', 'style': 'regular' },
    'solidFileExcel': { 'icon': 'file-excel', 'style': 'solid' },
    'fileExport': { 'icon': 'file-export', 'style': 'solid' },
    'fileImage': { 'icon': 'file-image', 'style': 'regular' },
    'solidFileImage': { 'icon': 'file-image', 'style': 'solid' },
    'fileImport': { 'icon': 'file-import', 'style': 'solid' },
    'fileInvoice': { 'icon': 'file-invoice', 'style': 'solid' },
    'fileInvoiceDollar': { 'icon': 'file-invoice-dollar', 'style': 'solid' },
    'fileMedical': { 'icon': 'file-medical', 'style': 'solid' },
    'fileMedicalAlt': { 'icon': 'file-medical-alt', 'style': 'solid' },
    'filePdf': { 'icon': 'file-pdf', 'style': 'regular' },
    'solidFilePdf': { 'icon': 'file-pdf', 'style': 'solid' },
    'filePowerpoint': { 'icon': 'file-powerpoint', 'style': 'regular' },
    'solidFilePowerpoint': { 'icon': 'file-powerpoint', 'style': 'solid' },
    'filePrescription': { 'icon': 'file-prescription', 'style': 'solid' },
    'fileSignature': { 'icon': 'file-signature', 'style': 'solid' },
    'fileUpload': { 'icon': 'file-upload', 'style': 'solid' },
    'fileVideo': { 'icon': 'file-video', 'style': 'regular' },
    'solidFileVideo': { 'icon': 'file-video', 'style': 'solid' },
    'fileWord': { 'icon': 'file-word', 'style': 'regular' },
    'solidFileWord': { 'icon': 'file-word', 'style': 'solid' },
    'fill': { 'icon': 'fill', 'style': 'solid' },
    'fillDrip': { 'icon': 'fill-drip', 'style': 'solid' },
    'film': { 'icon': 'film', 'style': 'solid' },
    'filter': { 'icon': 'filter', 'style': 'solid' },
    'fingerprint': { 'icon': 'fingerprint', 'style': 'solid' },
    'fire': { 'icon': 'fire', 'style': 'solid' },
    'fireAlt': { 'icon': 'fire-alt', 'style': 'solid' },
    'fireExtinguisher': { 'icon': 'fire-extinguisher', 'style': 'solid' },
    'firefox': { 'icon': 'firefox', 'style': 'brands' },
    'firefoxBrowser': { 'icon': 'firefox-browser', 'style': 'brands' },
    'firstAid': { 'icon': 'first-aid', 'style': 'solid' },
    'firstOrder': { 'icon': 'first-order', 'style': 'brands' },
    'firstOrderAlt': { 'icon': 'first-order-alt', 'style': 'brands' },
    'firstdraft': { 'icon': 'firstdraft', 'style': 'brands' },
    'fish': { 'icon': 'fish', 'style': 'solid' },
    'fistRaised': { 'icon': 'fist-raised', 'style': 'solid' },
    'flag': { 'icon': 'flag', 'style': 'regular' },
    'solidFlag': { 'icon': 'flag', 'style': 'solid' },
    'flagCheckered': { 'icon': 'flag-checkered', 'style': 'solid' },
    'flagUsa': { 'icon': 'flag-usa', 'style': 'solid' },
    'flask': { 'icon': 'flask', 'style': 'solid' },
    'flickr': { 'icon': 'flickr', 'style': 'brands' },
    'flipboard': { 'icon': 'flipboard', 'style': 'brands' },
    'flushed': { 'icon': 'flushed', 'style': 'regular' },
    'solidFlushed': { 'icon': 'flushed', 'style': 'solid' },
    'fly': { 'icon': 'fly', 'style': 'brands' },
    'folder': { 'icon': 'folder', 'style': 'regular' },
    'solidFolder': { 'icon': 'folder', 'style': 'solid' },
    'folderMinus': { 'icon': 'folder-minus', 'style': 'solid' },
    'folderOpen': { 'icon': 'folder-open', 'style': 'regular' },
    'solidFolderOpen': { 'icon': 'folder-open', 'style': 'solid' },
    'folderPlus': { 'icon': 'folder-plus', 'style': 'solid' },
    'font': { 'icon': 'font', 'style': 'solid' },
    'fontAwesome': { 'icon': 'font-awesome', 'style': 'brands' },
    'fontAwesomeAlt': { 'icon': 'font-awesome-alt', 'style': 'brands' },
    'fontAwesomeFlag': { 'icon': 'font-awesome-flag', 'style': 'brands' },
    'fonticons': { 'icon': 'fonticons', 'style': 'brands' },
    'fonticonsFi': { 'icon': 'fonticons-fi', 'style': 'brands' },
    'footballBall': { 'icon': 'football-ball', 'style': 'solid' },
    'fortAwesome': { 'icon': 'fort-awesome', 'style': 'brands' },
    'fortAwesomeAlt': { 'icon': 'fort-awesome-alt', 'style': 'brands' },
    'forumbee': { 'icon': 'forumbee', 'style': 'brands' },
    'forward': { 'icon': 'forward', 'style': 'solid' },
    'foursquare': { 'icon': 'foursquare', 'style': 'brands' },
    'freeCodeCamp': { 'icon': 'free-code-camp', 'style': 'brands' },
    'freebsd': { 'icon': 'freebsd', 'style': 'brands' },
    'frog': { 'icon': 'frog', 'style': 'solid' },
    'frown': { 'icon': 'frown', 'style': 'regular' },
    'solidFrown': { 'icon': 'frown', 'style': 'solid' },
    'frownOpen': { 'icon': 'frown-open', 'style': 'regular' },
    'solidFrownOpen': { 'icon': 'frown-open', 'style': 'solid' },
    'fulcrum': { 'icon': 'fulcrum', 'style': 'brands' },
    'funnelDollar': { 'icon': 'funnel-dollar', 'style': 'solid' },
    'futbol': { 'icon': 'futbol', 'style': 'regular' },
    'solidFutbol': { 'icon': 'futbol', 'style': 'solid' },
    'galacticRepublic': { 'icon': 'galactic-republic', 'style': 'brands' },
    'galacticSenate': { 'icon': 'galactic-senate', 'style': 'brands' },
    'gamepad': { 'icon': 'gamepad', 'style': 'solid' },
    'gasPump': { 'icon': 'gas-pump', 'style': 'solid' },
    'gavel': { 'icon': 'gavel', 'style': 'solid' },
    'gem': { 'icon': 'gem', 'style': 'regular' },
    'solidGem': { 'icon': 'gem', 'style': 'solid' },
    'genderless': { 'icon': 'genderless', 'style': 'solid' },
    'getPocket': { 'icon': 'get-pocket', 'style': 'brands' },
    'ggCircle': { 'icon': 'gg-circle', 'style': 'brands' },
    'ghost': { 'icon': 'ghost', 'style': 'solid' },
    'gift': { 'icon': 'gift', 'style': 'solid' },
    'gifts': { 'icon': 'gifts', 'style': 'solid' },
    'git': { 'icon': 'git', 'style': 'brands' },
    'gitAlt': { 'icon': 'git-alt', 'style': 'brands' },
    'gitSquare': { 'icon': 'git-square', 'style': 'brands' },
    'github': { 'icon': 'github', 'style': 'brands' },
    'githubAlt': { 'icon': 'github-alt', 'style': 'brands' },
    'githubSquare': { 'icon': 'github-square', 'style': 'brands' },
    'gitkraken': { 'icon': 'gitkraken', 'style': 'brands' },
    'gitlab': { 'icon': 'gitlab', 'style': 'brands' },
    'gitter': { 'icon': 'gitter', 'style': 'brands' },
    'glassCheers': { 'icon': 'glass-cheers', 'style': 'solid' },
    'glassMartini': { 'icon': 'glass-martini', 'style': 'solid' },
    'glassMartiniAlt': { 'icon': 'glass-martini-alt', 'style': 'solid' },
    'glassWhiskey': { 'icon': 'glass-whiskey', 'style': 'solid' },
    'glasses': { 'icon': 'glasses', 'style': 'solid' },
    'glide': { 'icon': 'glide', 'style': 'brands' },
    'glideG': { 'icon': 'glide-g', 'style': 'brands' },
    'globe': { 'icon': 'globe', 'style': 'solid' },
    'globeAfrica': { 'icon': 'globe-africa', 'style': 'solid' },
    'globeAmericas': { 'icon': 'globe-americas', 'style': 'solid' },
    'globeAsia': { 'icon': 'globe-asia', 'style': 'solid' },
    'globeEurope': { 'icon': 'globe-europe', 'style': 'solid' },
    'gofore': { 'icon': 'gofore', 'style': 'brands' },
    'golfBall': { 'icon': 'golf-ball', 'style': 'solid' },
    'goodreads': { 'icon': 'goodreads', 'style': 'brands' },
    'goodreadsG': { 'icon': 'goodreads-g', 'style': 'brands' },
    'google': { 'icon': 'google', 'style': 'brands' },
    'googleDrive': { 'icon': 'google-drive', 'style': 'brands' },
    'googlePay': { 'icon': 'google-pay', 'style': 'brands' },
    'googlePlay': { 'icon': 'google-play', 'style': 'brands' },
    'googlePlus': { 'icon': 'google-plus', 'style': 'brands' },
    'googlePlusG': { 'icon': 'google-plus-g', 'style': 'brands' },
    'googlePlusSquare': { 'icon': 'google-plus-square', 'style': 'brands' },
    'googleWallet': { 'icon': 'google-wallet', 'style': 'brands' },
    'gopuram': { 'icon': 'gopuram', 'style': 'solid' },
    'graduationCap': { 'icon': 'graduation-cap', 'style': 'solid' },
    'gratipay': { 'icon': 'gratipay', 'style': 'brands' },
    'grav': { 'icon': 'grav', 'style': 'brands' },
    'greaterThan': { 'icon': 'greater-than', 'style': 'solid' },
    'greaterThanEqual': { 'icon': 'greater-than-equal', 'style': 'solid' },
    'grimace': { 'icon': 'grimace', 'style': 'regular' },
    'solidGrimace': { 'icon': 'grimace', 'style': 'solid' },
    'grin': { 'icon': 'grin', 'style': 'regular' },
    'solidGrin': { 'icon': 'grin', 'style': 'solid' },
    'grinAlt': { 'icon': 'grin-alt', 'style': 'regular' },
    'solidGrinAlt': { 'icon': 'grin-alt', 'style': 'solid' },
    'grinBeam': { 'icon': 'grin-beam', 'style': 'regular' },
    'solidGrinBeam': { 'icon': 'grin-beam', 'style': 'solid' },
    'grinBeamSweat': { 'icon': 'grin-beam-sweat', 'style': 'regular' },
    'solidGrinBeamSweat': { 'icon': 'grin-beam-sweat', 'style': 'solid' },
    'grinHearts': { 'icon': 'grin-hearts', 'style': 'regular' },
    'solidGrinHearts': { 'icon': 'grin-hearts', 'style': 'solid' },
    'grinSquint': { 'icon': 'grin-squint', 'style': 'regular' },
    'solidGrinSquint': { 'icon': 'grin-squint', 'style': 'solid' },
    'grinSquintTears': { 'icon': 'grin-squint-tears', 'style': 'regular' },
    'solidGrinSquintTears': { 'icon': 'grin-squint-tears', 'style': 'solid' },
    'grinStars': { 'icon': 'grin-stars', 'style': 'regular' },
    'solidGrinStars': { 'icon': 'grin-stars', 'style': 'solid' },
    'grinTears': { 'icon': 'grin-tears', 'style': 'regular' },
    'solidGrinTears': { 'icon': 'grin-tears', 'style': 'solid' },
    'grinTongue': { 'icon': 'grin-tongue', 'style': 'regular' },
    'solidGrinTongue': { 'icon': 'grin-tongue', 'style': 'solid' },
    'grinTongueSquint': { 'icon': 'grin-tongue-squint', 'style': 'regular' },
    'solidGrinTongueSquint': { 'icon': 'grin-tongue-squint', 'style': 'solid' },
    'grinTongueWink': { 'icon': 'grin-tongue-wink', 'style': 'regular' },
    'solidGrinTongueWink': { 'icon': 'grin-tongue-wink', 'style': 'solid' },
    'grinWink': { 'icon': 'grin-wink', 'style': 'regular' },
    'solidGrinWink': { 'icon': 'grin-wink', 'style': 'solid' },
    'gripHorizontal': { 'icon': 'grip-horizontal', 'style': 'solid' },
    'gripLines': { 'icon': 'grip-lines', 'style': 'solid' },
    'gripLinesVertical': { 'icon': 'grip-lines-vertical', 'style': 'solid' },
    'gripVertical': { 'icon': 'grip-vertical', 'style': 'solid' },
    'gripfire': { 'icon': 'gripfire', 'style': 'brands' },
    'grunt': { 'icon': 'grunt', 'style': 'brands' },
    'guilded': { 'icon': 'guilded', 'style': 'brands' },
    'guitar': { 'icon': 'guitar', 'style': 'solid' },
    'gulp': { 'icon': 'gulp', 'style': 'brands' },
    'hSquare': { 'icon': 'h-square', 'style': 'solid' },
    'hackerNews': { 'icon': 'hacker-news', 'style': 'brands' },
    'hackerNewsSquare': { 'icon': 'hacker-news-square', 'style': 'brands' },
    'hackerrank': { 'icon': 'hackerrank', 'style': 'brands' },
    'hamburger': { 'icon': 'hamburger', 'style': 'solid' },
    'hammer': { 'icon': 'hammer', 'style': 'solid' },
    'hamsa': { 'icon': 'hamsa', 'style': 'solid' },
    'handHolding': { 'icon': 'hand-holding', 'style': 'solid' },
    'handHoldingHeart': { 'icon': 'hand-holding-heart', 'style': 'solid' },
    'handHoldingMedical': { 'icon': 'hand-holding-medical', 'style': 'solid' },
    'handHoldingUsd': { 'icon': 'hand-holding-usd', 'style': 'solid' },
    'handHoldingWater': { 'icon': 'hand-holding-water', 'style': 'solid' },
    'handLizard': { 'icon': 'hand-lizard', 'style': 'regular' },
    'solidHandLizard': { 'icon': 'hand-lizard', 'style': 'solid' },
    'handMiddleFinger': { 'icon': 'hand-middle-finger', 'style': 'solid' },
    'handPaper': { 'icon': 'hand-paper', 'style': 'regular' },
    'solidHandPaper': { 'icon': 'hand-paper', 'style': 'solid' },
    'handPeace': { 'icon': 'hand-peace', 'style': 'regular' },
    'solidHandPeace': { 'icon': 'hand-peace', 'style': 'solid' },
    'handPointDown': { 'icon': 'hand-point-down', 'style': 'regular' },
    'solidHandPointDown': { 'icon': 'hand-point-down', 'style': 'solid' },
    'handPointLeft': { 'icon': 'hand-point-left', 'style': 'regular' },
    'solidHandPointLeft': { 'icon': 'hand-point-left', 'style': 'solid' },
    'handPointRight': { 'icon': 'hand-point-right', 'style': 'regular' },
    'solidHandPointRight': { 'icon': 'hand-point-right', 'style': 'solid' },
    'handPointUp': { 'icon': 'hand-point-up', 'style': 'regular' },
    'solidHandPointUp': { 'icon': 'hand-point-up', 'style': 'solid' },
    'handPointer': { 'icon': 'hand-pointer', 'style': 'regular' },
    'solidHandPointer': { 'icon': 'hand-pointer', 'style': 'solid' },
    'handRock': { 'icon': 'hand-rock', 'style': 'regular' },
    'solidHandRock': { 'icon': 'hand-rock', 'style': 'solid' },
    'handScissors': { 'icon': 'hand-scissors', 'style': 'regular' },
    'solidHandScissors': { 'icon': 'hand-scissors', 'style': 'solid' },
    'handSparkles': { 'icon': 'hand-sparkles', 'style': 'solid' },
    'handSpock': { 'icon': 'hand-spock', 'style': 'regular' },
    'solidHandSpock': { 'icon': 'hand-spock', 'style': 'solid' },
    'hands': { 'icon': 'hands', 'style': 'solid' },
    'handsHelping': { 'icon': 'hands-helping', 'style': 'solid' },
    'handsWash': { 'icon': 'hands-wash', 'style': 'solid' },
    'handshake': { 'icon': 'handshake', 'style': 'regular' },
    'solidHandshake': { 'icon': 'handshake', 'style': 'solid' },
    'handshakeAltSlash': { 'icon': 'handshake-alt-slash', 'style': 'solid' },
    'handshakeSlash': { 'icon': 'handshake-slash', 'style': 'solid' },
    'hanukiah': { 'icon': 'hanukiah', 'style': 'solid' },
    'hardHat': { 'icon': 'hard-hat', 'style': 'solid' },
    'hashtag': { 'icon': 'hashtag', 'style': 'solid' },
    'hatCowboy': { 'icon': 'hat-cowboy', 'style': 'solid' },
    'hatCowboySide': { 'icon': 'hat-cowboy-side', 'style': 'solid' },
    'hatWizard': { 'icon': 'hat-wizard', 'style': 'solid' },
    'hdd': { 'icon': 'hdd', 'style': 'regular' },
    'solidHdd': { 'icon': 'hdd', 'style': 'solid' },
    'headSideCough': { 'icon': 'head-side-cough', 'style': 'solid' },
    'headSideCoughSlash': { 'icon': 'head-side-cough-slash', 'style': 'solid' },
    'headSideMask': { 'icon': 'head-side-mask', 'style': 'solid' },
    'headSideVirus': { 'icon': 'head-side-virus', 'style': 'solid' },
    'heading': { 'icon': 'heading', 'style': 'solid' },
    'headphones': { 'icon': 'headphones', 'style': 'solid' },
    'headphonesAlt': { 'icon': 'headphones-alt', 'style': 'solid' },
    'headset': { 'icon': 'headset', 'style': 'solid' },
    'heart': { 'icon': 'heart', 'style': 'regular' },
    'solidHeart': { 'icon': 'heart', 'style': 'solid' },
    'heartBroken': { 'icon': 'heart-broken', 'style': 'solid' },
    'heartbeat': { 'icon': 'heartbeat', 'style': 'solid' },
    'helicopter': { 'icon': 'helicopter', 'style': 'solid' },
    'highlighter': { 'icon': 'highlighter', 'style': 'solid' },
    'hiking': { 'icon': 'hiking', 'style': 'solid' },
    'hippo': { 'icon': 'hippo', 'style': 'solid' },
    'hips': { 'icon': 'hips', 'style': 'brands' },
    'hireAHelper': { 'icon': 'hire-a-helper', 'style': 'brands' },
    'history': { 'icon': 'history', 'style': 'solid' },
    'hive': { 'icon': 'hive', 'style': 'brands' },
    'hockeyPuck': { 'icon': 'hockey-puck', 'style': 'solid' },
    'hollyBerry': { 'icon': 'holly-berry', 'style': 'solid' },
    'home': { 'icon': 'home', 'style': 'solid' },
    'hooli': { 'icon': 'hooli', 'style': 'brands' },
    'hornbill': { 'icon': 'hornbill', 'style': 'brands' },
    'horse': { 'icon': 'horse', 'style': 'solid' },
    'horseHead': { 'icon': 'horse-head', 'style': 'solid' },
    'hospital': { 'icon': 'hospital', 'style': 'regular' },
    'solidHospital': { 'icon': 'hospital', 'style': 'solid' },
    'hospitalAlt': { 'icon': 'hospital-alt', 'style': 'solid' },
    'hospitalSymbol': { 'icon': 'hospital-symbol', 'style': 'solid' },
    'hospitalUser': { 'icon': 'hospital-user', 'style': 'solid' },
    'hotTub': { 'icon': 'hot-tub', 'style': 'solid' },
    'hotdog': { 'icon': 'hotdog', 'style': 'solid' },
    'hotel': { 'icon': 'hotel', 'style': 'solid' },
    'hotjar': { 'icon': 'hotjar', 'style': 'brands' },
    'hourglass': { 'icon': 'hourglass', 'style': 'regular' },
    'solidHourglass': { 'icon': 'hourglass', 'style': 'solid' },
    'hourglassEnd': { 'icon': 'hourglass-end', 'style': 'solid' },
    'hourglassHalf': { 'icon': 'hourglass-half', 'style': 'solid' },
    'hourglassStart': { 'icon': 'hourglass-start', 'style': 'solid' },
    'houseDamage': { 'icon': 'house-damage', 'style': 'solid' },
    'houseUser': { 'icon': 'house-user', 'style': 'solid' },
    'houzz': { 'icon': 'houzz', 'style': 'brands' },
    'hryvnia': { 'icon': 'hryvnia', 'style': 'solid' },
    'html5': { 'icon': 'html5', 'style': 'brands' },
    'hubspot': { 'icon': 'hubspot', 'style': 'brands' },
    'iCursor': { 'icon': 'i-cursor', 'style': 'solid' },
    'iceCream': { 'icon': 'ice-cream', 'style': 'solid' },
    'icicles': { 'icon': 'icicles', 'style': 'solid' },
    'icons': { 'icon': 'icons', 'style': 'solid' },
    'idBadge': { 'icon': 'id-badge', 'style': 'regular' },
    'solidIdBadge': { 'icon': 'id-badge', 'style': 'solid' },
    'idCard': { 'icon': 'id-card', 'style': 'regular' },
    'solidIdCard': { 'icon': 'id-card', 'style': 'solid' },
    'idCardAlt': { 'icon': 'id-card-alt', 'style': 'solid' },
    'ideal': { 'icon': 'ideal', 'style': 'brands' },
    'igloo': { 'icon': 'igloo', 'style': 'solid' },
    'image': { 'icon': 'image', 'style': 'regular' },
    'solidImage': { 'icon': 'image', 'style': 'solid' },
    'images': { 'icon': 'images', 'style': 'regular' },
    'solidImages': { 'icon': 'images', 'style': 'solid' },
    'imdb': { 'icon': 'imdb', 'style': 'brands' },
    'inbox': { 'icon': 'inbox', 'style': 'solid' },
    'indent': { 'icon': 'indent', 'style': 'solid' },
    'industry': { 'icon': 'industry', 'style': 'solid' },
    'infinity': { 'icon': 'infinity', 'style': 'solid' },
    'info': { 'icon': 'info', 'style': 'solid' },
    'infoCircle': { 'icon': 'info-circle', 'style': 'solid' },
    'innosoft': { 'icon': 'innosoft', 'style': 'brands' },
    'instagram': { 'icon': 'instagram', 'style': 'brands' },
    'instagramSquare': { 'icon': 'instagram-square', 'style': 'brands' },
    'instalod': { 'icon': 'instalod', 'style': 'brands' },
    'intercom': { 'icon': 'intercom', 'style': 'brands' },
    'internetExplorer': { 'icon': 'internet-explorer', 'style': 'brands' },
    'invision': { 'icon': 'invision', 'style': 'brands' },
    'ioxhost': { 'icon': 'ioxhost', 'style': 'brands' },
    'italic': { 'icon': 'italic', 'style': 'solid' },
    'itchIo': { 'icon': 'itch-io', 'style': 'brands' },
    'itunes': { 'icon': 'itunes', 'style': 'brands' },
    'itunesNote': { 'icon': 'itunes-note', 'style': 'brands' },
    'java': { 'icon': 'java', 'style': 'brands' },
    'jedi': { 'icon': 'jedi', 'style': 'solid' },
    'jediOrder': { 'icon': 'jedi-order', 'style': 'brands' },
    'jenkins': { 'icon': 'jenkins', 'style': 'brands' },
    'jira': { 'icon': 'jira', 'style': 'brands' },
    'joget': { 'icon': 'joget', 'style': 'brands' },
    'joint': { 'icon': 'joint', 'style': 'solid' },
    'joomla': { 'icon': 'joomla', 'style': 'brands' },
    'journalWhills': { 'icon': 'journal-whills', 'style': 'solid' },
    'jsSquare': { 'icon': 'js-square', 'style': 'brands' },
    'jsfiddle': { 'icon': 'jsfiddle', 'style': 'brands' },
    'kaaba': { 'icon': 'kaaba', 'style': 'solid' },
    'kaggle': { 'icon': 'kaggle', 'style': 'brands' },
    'key': { 'icon': 'key', 'style': 'solid' },
    'keybase': { 'icon': 'keybase', 'style': 'brands' },
    'keyboard': { 'icon': 'keyboard', 'style': 'regular' },
    'solidKeyboard': { 'icon': 'keyboard', 'style': 'solid' },
    'keycdn': { 'icon': 'keycdn', 'style': 'brands' },
    'khanda': { 'icon': 'khanda', 'style': 'solid' },
    'kickstarter': { 'icon': 'kickstarter', 'style': 'brands' },
    'kickstarterK': { 'icon': 'kickstarter-k', 'style': 'brands' },
    'kiss': { 'icon': 'kiss', 'style': 'regular' },
    'solidKiss': { 'icon': 'kiss', 'style': 'solid' },
    'kissBeam': { 'icon': 'kiss-beam', 'style': 'regular' },
    'solidKissBeam': { 'icon': 'kiss-beam', 'style': 'solid' },
    'kissWinkHeart': { 'icon': 'kiss-wink-heart', 'style': 'regular' },
    'solidKissWinkHeart': { 'icon': 'kiss-wink-heart', 'style': 'solid' },
    'kiwiBird': { 'icon': 'kiwi-bird', 'style': 'solid' },
    'korvue': { 'icon': 'korvue', 'style': 'brands' },
    'landmark': { 'icon': 'landmark', 'style': 'solid' },
    'language': { 'icon': 'language', 'style': 'solid' },
    'laptop': { 'icon': 'laptop', 'style': 'solid' },
    'laptopCode': { 'icon': 'laptop-code', 'style': 'solid' },
    'laptopHouse': { 'icon': 'laptop-house', 'style': 'solid' },
    'laptopMedical': { 'icon': 'laptop-medical', 'style': 'solid' },
    'laravel': { 'icon': 'laravel', 'style': 'brands' },
    'lastfm': { 'icon': 'lastfm', 'style': 'brands' },
    'lastfmSquare': { 'icon': 'lastfm-square', 'style': 'brands' },
    'laugh': { 'icon': 'laugh', 'style': 'regular' },
    'solidLaugh': { 'icon': 'laugh', 'style': 'solid' },
    'laughBeam': { 'icon': 'laugh-beam', 'style': 'regular' },
    'solidLaughBeam': { 'icon': 'laugh-beam', 'style': 'solid' },
    'laughSquint': { 'icon': 'laugh-squint', 'style': 'regular' },
    'solidLaughSquint': { 'icon': 'laugh-squint', 'style': 'solid' },
    'laughWink': { 'icon': 'laugh-wink', 'style': 'regular' },
    'solidLaughWink': { 'icon': 'laugh-wink', 'style': 'solid' },
    'layerGroup': { 'icon': 'layer-group', 'style': 'solid' },
    'leaf': { 'icon': 'leaf', 'style': 'solid' },
    'leanpub': { 'icon': 'leanpub', 'style': 'brands' },
    'lemon': { 'icon': 'lemon', 'style': 'regular' },
    'solidLemon': { 'icon': 'lemon', 'style': 'solid' },
    'less': { 'icon': 'less', 'style': 'brands' },
    'lessThan': { 'icon': 'less-than', 'style': 'solid' },
    'lessThanEqual': { 'icon': 'less-than-equal', 'style': 'solid' },
    'levelDownAlt': { 'icon': 'level-down-alt', 'style': 'solid' },
    'levelUpAlt': { 'icon': 'level-up-alt', 'style': 'solid' },
    'lifeRing': { 'icon': 'life-ring', 'style': 'regular' },
    'solidLifeRing': { 'icon': 'life-ring', 'style': 'solid' },
    'lightbulb': { 'icon': 'lightbulb', 'style': 'regular' },
    'solidLightbulb': { 'icon': 'lightbulb', 'style': 'solid' },
    'line': { 'icon': 'line', 'style': 'brands' },
    'link': { 'icon': 'link', 'style': 'solid' },
    'linkedin': { 'icon': 'linkedin', 'style': 'brands' },
    'linkedinIn': { 'icon': 'linkedin-in', 'style': 'brands' },
    'linode': { 'icon': 'linode', 'style': 'brands' },
    'linux': { 'icon': 'linux', 'style': 'brands' },
    'liraSign': { 'icon': 'lira-sign', 'style': 'solid' },
    'list': { 'icon': 'list', 'style': 'solid' },
    'listAlt': { 'icon': 'list-alt', 'style': 'regular' },
    'solidListAlt': { 'icon': 'list-alt', 'style': 'solid' },
    'listOl': { 'icon': 'list-ol', 'style': 'solid' },
    'listUl': { 'icon': 'list-ul', 'style': 'solid' },
    'locationArrow': { 'icon': 'location-arrow', 'style': 'solid' },
    'lock': { 'icon': 'lock', 'style': 'solid' },
    'lockOpen': { 'icon': 'lock-open', 'style': 'solid' },
    'longArrowAltDown': { 'icon': 'long-arrow-alt-down', 'style': 'solid' },
    'longArrowAltLeft': { 'icon': 'long-arrow-alt-left', 'style': 'solid' },
    'longArrowAltRight': { 'icon': 'long-arrow-alt-right', 'style': 'solid' },
    'longArrowAltUp': { 'icon': 'long-arrow-alt-up', 'style': 'solid' },
    'lowVision': { 'icon': 'low-vision', 'style': 'solid' },
    'luggageCart': { 'icon': 'luggage-cart', 'style': 'solid' },
    'lungs': { 'icon': 'lungs', 'style': 'solid' },
    'lungsVirus': { 'icon': 'lungs-virus', 'style': 'solid' },
    'lyft': { 'icon': 'lyft', 'style': 'brands' },
    'magento': { 'icon': 'magento', 'style': 'brands' },
    'magic': { 'icon': 'magic', 'style': 'solid' },
    'magnet': { 'icon': 'magnet', 'style': 'solid' },
    'mailBulk': { 'icon': 'mail-bulk', 'style': 'solid' },
    'mailchimp': { 'icon': 'mailchimp', 'style': 'brands' },
    'male': { 'icon': 'male', 'style': 'solid' },
    'mandalorian': { 'icon': 'mandalorian', 'style': 'brands' },
    'map': { 'icon': 'map', 'style': 'regular' },
    'solidMap': { 'icon': 'map', 'style': 'solid' },
    'mapMarked': { 'icon': 'map-marked', 'style': 'solid' },
    'mapMarkedAlt': { 'icon': 'map-marked-alt', 'style': 'solid' },
    'mapMarker': { 'icon': 'map-marker', 'style': 'solid' },
    'mapMarkerAlt': { 'icon': 'map-marker-alt', 'style': 'solid' },
    'mapPin': { 'icon': 'map-pin', 'style': 'solid' },
    'mapSigns': { 'icon': 'map-signs', 'style': 'solid' },
    'markdown': { 'icon': 'markdown', 'style': 'brands' },
    'marker': { 'icon': 'marker', 'style': 'solid' },
    'mars': { 'icon': 'mars', 'style': 'solid' },
    'marsDouble': { 'icon': 'mars-double', 'style': 'solid' },
    'marsStroke': { 'icon': 'mars-stroke', 'style': 'solid' },
    'marsStrokeH': { 'icon': 'mars-stroke-h', 'style': 'solid' },
    'marsStrokeV': { 'icon': 'mars-stroke-v', 'style': 'solid' },
    'mask': { 'icon': 'mask', 'style': 'solid' },
    'mastodon': { 'icon': 'mastodon', 'style': 'brands' },
    'maxcdn': { 'icon': 'maxcdn', 'style': 'brands' },
    'mdb': { 'icon': 'mdb', 'style': 'brands' },
    'medal': { 'icon': 'medal', 'style': 'solid' },
    'medapps': { 'icon': 'medapps', 'style': 'brands' },
    'medium': { 'icon': 'medium', 'style': 'brands' },
    'mediumM': { 'icon': 'medium-m', 'style': 'brands' },
    'medkit': { 'icon': 'medkit', 'style': 'solid' },
    'medrt': { 'icon': 'medrt', 'style': 'brands' },
    'meetup': { 'icon': 'meetup', 'style': 'brands' },
    'megaport': { 'icon': 'megaport', 'style': 'brands' },
    'meh': { 'icon': 'meh', 'style': 'regular' },
    'solidMeh': { 'icon': 'meh', 'style': 'solid' },
    'mehBlank': { 'icon': 'meh-blank', 'style': 'regular' },
    'solidMehBlank': { 'icon': 'meh-blank', 'style': 'solid' },
    'mehRollingEyes': { 'icon': 'meh-rolling-eyes', 'style': 'regular' },
    'solidMehRollingEyes': { 'icon': 'meh-rolling-eyes', 'style': 'solid' },
    'memory': { 'icon': 'memory', 'style': 'solid' },
    'mendeley': { 'icon': 'mendeley', 'style': 'brands' },
    'menorah': { 'icon': 'menorah', 'style': 'solid' },
    'mercury': { 'icon': 'mercury', 'style': 'solid' },
    'meteor': { 'icon': 'meteor', 'style': 'solid' },
    'microblog': { 'icon': 'microblog', 'style': 'brands' },
    'microchip': { 'icon': 'microchip', 'style': 'solid' },
    'microphone': { 'icon': 'microphone', 'style': 'solid' },
    'microphoneAlt': { 'icon': 'microphone-alt', 'style': 'solid' },
    'microphoneAltSlash': { 'icon': 'microphone-alt-slash', 'style': 'solid' },
    'microphoneSlash': { 'icon': 'microphone-slash', 'style': 'solid' },
    'microscope': { 'icon': 'microscope', 'style': 'solid' },
    'microsoft': { 'icon': 'microsoft', 'style': 'brands' },
    'minus': { 'icon': 'minus', 'style': 'solid' },
    'minusCircle': { 'icon': 'minus-circle', 'style': 'solid' },
    'minusSquare': { 'icon': 'minus-square', 'style': 'regular' },
    'solidMinusSquare': { 'icon': 'minus-square', 'style': 'solid' },
    'mitten': { 'icon': 'mitten', 'style': 'solid' },
    'mix': { 'icon': 'mix', 'style': 'brands' },
    'mixcloud': { 'icon': 'mixcloud', 'style': 'brands' },
    'mixer': { 'icon': 'mixer', 'style': 'brands' },
    'mizuni': { 'icon': 'mizuni', 'style': 'brands' },
    'mobile': { 'icon': 'mobile', 'style': 'solid' },
    'mobileAlt': { 'icon': 'mobile-alt', 'style': 'solid' },
    'modx': { 'icon': 'modx', 'style': 'brands' },
    'monero': { 'icon': 'monero', 'style': 'brands' },
    'moneyBill': { 'icon': 'money-bill', 'style': 'solid' },
    'moneyBillAlt': { 'icon': 'money-bill-alt', 'style': 'regular' },
    'solidMoneyBillAlt': { 'icon': 'money-bill-alt', 'style': 'solid' },
    'moneyBillWave': { 'icon': 'money-bill-wave', 'style': 'solid' },
    'moneyBillWaveAlt': { 'icon': 'money-bill-wave-alt', 'style': 'solid' },
    'moneyCheck': { 'icon': 'money-check', 'style': 'solid' },
    'moneyCheckAlt': { 'icon': 'money-check-alt', 'style': 'solid' },
    'monument': { 'icon': 'monument', 'style': 'solid' },
    'moon': { 'icon': 'moon', 'style': 'regular' },
    'solidMoon': { 'icon': 'moon', 'style': 'solid' },
    'mortarPestle': { 'icon': 'mortar-pestle', 'style': 'solid' },
    'mosque': { 'icon': 'mosque', 'style': 'solid' },
    'motorcycle': { 'icon': 'motorcycle', 'style': 'solid' },
    'mountain': { 'icon': 'mountain', 'style': 'solid' },
    'mouse': { 'icon': 'mouse', 'style': 'solid' },
    'mousePointer': { 'icon': 'mouse-pointer', 'style': 'solid' },
    'mugHot': { 'icon': 'mug-hot', 'style': 'solid' },
    'music': { 'icon': 'music', 'style': 'solid' },
    'napster': { 'icon': 'napster', 'style': 'brands' },
    'neos': { 'icon': 'neos', 'style': 'brands' },
    'networkWired': { 'icon': 'network-wired', 'style': 'solid' },
    'neuter': { 'icon': 'neuter', 'style': 'solid' },
    'newspaper': { 'icon': 'newspaper', 'style': 'regular' },
    'solidNewspaper': { 'icon': 'newspaper', 'style': 'solid' },
    'nimblr': { 'icon': 'nimblr', 'style': 'brands' },
    'node': { 'icon': 'node', 'style': 'brands' },
    'nodeJs': { 'icon': 'node-js', 'style': 'brands' },
    'notEqual': { 'icon': 'not-equal', 'style': 'solid' },
    'notesMedical': { 'icon': 'notes-medical', 'style': 'solid' },
    'npm': { 'icon': 'npm', 'style': 'brands' },
    'ns8': { 'icon': 'ns8', 'style': 'brands' },
    'nutritionix': { 'icon': 'nutritionix', 'style': 'brands' },
    'objectGroup': { 'icon': 'object-group', 'style': 'regular' },
    'solidObjectGroup': { 'icon': 'object-group', 'style': 'solid' },
    'objectUngroup': { 'icon': 'object-ungroup', 'style': 'regular' },
    'solidObjectUngroup': { 'icon': 'object-ungroup', 'style': 'solid' },
    'octopusDeploy': { 'icon': 'octopus-deploy', 'style': 'brands' },
    'odnoklassniki': { 'icon': 'odnoklassniki', 'style': 'brands' },
    'odnoklassnikiSquare': { 'icon': 'odnoklassniki-square', 'style': 'brands' },
    'oilCan': { 'icon': 'oil-can', 'style': 'solid' },
    'oldRepublic': { 'icon': 'old-republic', 'style': 'brands' },
    'opencart': { 'icon': 'opencart', 'style': 'brands' },
    'openid': { 'icon': 'openid', 'style': 'brands' },
    'opera': { 'icon': 'opera', 'style': 'brands' },
    'optinMonster': { 'icon': 'optin-monster', 'style': 'brands' },
    'orcid': { 'icon': 'orcid', 'style': 'brands' },
    'osi': { 'icon': 'osi', 'style': 'brands' },
    'otter': { 'icon': 'otter', 'style': 'solid' },
    'outdent': { 'icon': 'outdent', 'style': 'solid' },
    'page4': { 'icon': 'page4', 'style': 'brands' },
    'pagelines': { 'icon': 'pagelines', 'style': 'brands' },
    'pager': { 'icon': 'pager', 'style': 'solid' },
    'paintBrush': { 'icon': 'paint-brush', 'style': 'solid' },
    'paintRoller': { 'icon': 'paint-roller', 'style': 'solid' },
    'palette': { 'icon': 'palette', 'style': 'solid' },
    'palfed': { 'icon': 'palfed', 'style': 'brands' },
    'pallet': { 'icon': 'pallet', 'style': 'solid' },
    'paperPlane': { 'icon': 'paper-plane', 'style': 'regular' },
    'solidPaperPlane': { 'icon': 'paper-plane', 'style': 'solid' },
    'paperclip': { 'icon': 'paperclip', 'style': 'solid' },
    'parachuteBox': { 'icon': 'parachute-box', 'style': 'solid' },
    'paragraph': { 'icon': 'paragraph', 'style': 'solid' },
    'parking': { 'icon': 'parking', 'style': 'solid' },
    'passport': { 'icon': 'passport', 'style': 'solid' },
    'pastafarianism': { 'icon': 'pastafarianism', 'style': 'solid' },
    'paste': { 'icon': 'paste', 'style': 'solid' },
    'patreon': { 'icon': 'patreon', 'style': 'brands' },
    'pause': { 'icon': 'pause', 'style': 'solid' },
    'pauseCircle': { 'icon': 'pause-circle', 'style': 'regular' },
    'solidPauseCircle': { 'icon': 'pause-circle', 'style': 'solid' },
    'paw': { 'icon': 'paw', 'style': 'solid' },
    'paypal': { 'icon': 'paypal', 'style': 'brands' },
    'peace': { 'icon': 'peace', 'style': 'solid' },
    'pen': { 'icon': 'pen', 'style': 'solid' },
    'penAlt': { 'icon': 'pen-alt', 'style': 'solid' },
    'penFancy': { 'icon': 'pen-fancy', 'style': 'solid' },
    'penNib': { 'icon': 'pen-nib', 'style': 'solid' },
    'penSquare': { 'icon': 'pen-square', 'style': 'solid' },
    'pencilAlt': { 'icon': 'pencil-alt', 'style': 'solid' },
    'pencilRuler': { 'icon': 'pencil-ruler', 'style': 'solid' },
    'peopleArrows': { 'icon': 'people-arrows', 'style': 'solid' },
    'peopleCarry': { 'icon': 'people-carry', 'style': 'solid' },
    'pepperHot': { 'icon': 'pepper-hot', 'style': 'solid' },
    'perbyte': { 'icon': 'perbyte', 'style': 'brands' },
    'percent': { 'icon': 'percent', 'style': 'solid' },
    'percentage': { 'icon': 'percentage', 'style': 'solid' },
    'periscope': { 'icon': 'periscope', 'style': 'brands' },
    'personBooth': { 'icon': 'person-booth', 'style': 'solid' },
    'phabricator': { 'icon': 'phabricator', 'style': 'brands' },
    'phoenixFramework': { 'icon': 'phoenix-framework', 'style': 'brands' },
    'phoenixSquadron': { 'icon': 'phoenix-squadron', 'style': 'brands' },
    'phone': { 'icon': 'phone', 'style': 'solid' },
    'phoneAlt': { 'icon': 'phone-alt', 'style': 'solid' },
    'phoneSlash': { 'icon': 'phone-slash', 'style': 'solid' },
    'phoneSquare': { 'icon': 'phone-square', 'style': 'solid' },
    'phoneSquareAlt': { 'icon': 'phone-square-alt', 'style': 'solid' },
    'phoneVolume': { 'icon': 'phone-volume', 'style': 'solid' },
    'photoVideo': { 'icon': 'photo-video', 'style': 'solid' },
    'php': { 'icon': 'php', 'style': 'brands' },
    'piedPiper': { 'icon': 'pied-piper', 'style': 'brands' },
    'piedPiperAlt': { 'icon': 'pied-piper-alt', 'style': 'brands' },
    'piedPiperHat': { 'icon': 'pied-piper-hat', 'style': 'brands' },
    'piedPiperPp': { 'icon': 'pied-piper-pp', 'style': 'brands' },
    'piedPiperSquare': { 'icon': 'pied-piper-square', 'style': 'brands' },
    'piggyBank': { 'icon': 'piggy-bank', 'style': 'solid' },
    'pills': { 'icon': 'pills', 'style': 'solid' },
    'pinterest': { 'icon': 'pinterest', 'style': 'brands' },
    'pinterestP': { 'icon': 'pinterest-p', 'style': 'brands' },
    'pinterestSquare': { 'icon': 'pinterest-square', 'style': 'brands' },
    'pizzaSlice': { 'icon': 'pizza-slice', 'style': 'solid' },
    'placeOfWorship': { 'icon': 'place-of-worship', 'style': 'solid' },
    'plane': { 'icon': 'plane', 'style': 'solid' },
    'planeArrival': { 'icon': 'plane-arrival', 'style': 'solid' },
    'planeDeparture': { 'icon': 'plane-departure', 'style': 'solid' },
    'planeSlash': { 'icon': 'plane-slash', 'style': 'solid' },
    'play': { 'icon': 'play', 'style': 'solid' },
    'playCircle': { 'icon': 'play-circle', 'style': 'regular' },
    'solidPlayCircle': { 'icon': 'play-circle', 'style': 'solid' },
    'playstation': { 'icon': 'playstation', 'style': 'brands' },
    'plug': { 'icon': 'plug', 'style': 'solid' },
    'plus': { 'icon': 'plus', 'style': 'solid' },
    'plusCircle': { 'icon': 'plus-circle', 'style': 'solid' },
    'plusSquare': { 'icon': 'plus-square', 'style': 'regular' },
    'solidPlusSquare': { 'icon': 'plus-square', 'style': 'solid' },
    'podcast': { 'icon': 'podcast', 'style': 'solid' },
    'poll': { 'icon': 'poll', 'style': 'solid' },
    'pollH': { 'icon': 'poll-h', 'style': 'solid' },
    'poo': { 'icon': 'poo', 'style': 'solid' },
    'pooStorm': { 'icon': 'poo-storm', 'style': 'solid' },
    'poop': { 'icon': 'poop', 'style': 'solid' },
    'portrait': { 'icon': 'portrait', 'style': 'solid' },
    'poundSign': { 'icon': 'pound-sign', 'style': 'solid' },
    'powerOff': { 'icon': 'power-off', 'style': 'solid' },
    'pray': { 'icon': 'pray', 'style': 'solid' },
    'prayingHands': { 'icon': 'praying-hands', 'style': 'solid' },
    'prescription': { 'icon': 'prescription', 'style': 'solid' },
    'prescriptionBottle': { 'icon': 'prescription-bottle', 'style': 'solid' },
    'prescriptionBottleAlt': { 'icon': 'prescription-bottle-alt', 'style': 'solid' },
    'print': { 'icon': 'print', 'style': 'solid' },
    'procedures': { 'icon': 'procedures', 'style': 'solid' },
    'productHunt': { 'icon': 'product-hunt', 'style': 'brands' },
    'projectDiagram': { 'icon': 'project-diagram', 'style': 'solid' },
    'pumpMedical': { 'icon': 'pump-medical', 'style': 'solid' },
    'pumpSoap': { 'icon': 'pump-soap', 'style': 'solid' },
    'pushed': { 'icon': 'pushed', 'style': 'brands' },
    'puzzlePiece': { 'icon': 'puzzle-piece', 'style': 'solid' },
    'python': { 'icon': 'python', 'style': 'brands' },
    'qrcode': { 'icon': 'qrcode', 'style': 'solid' },
    'question': { 'icon': 'question', 'style': 'solid' },
    'questionCircle': { 'icon': 'question-circle', 'style': 'regular' },
    'solidQuestionCircle': { 'icon': 'question-circle', 'style': 'solid' },
    'quidditch': { 'icon': 'quidditch', 'style': 'solid' },
    'quinscape': { 'icon': 'quinscape', 'style': 'brands' },
    'quora': { 'icon': 'quora', 'style': 'brands' },
    'quoteLeft': { 'icon': 'quote-left', 'style': 'solid' },
    'quoteRight': { 'icon': 'quote-right', 'style': 'solid' },
    'quran': { 'icon': 'quran', 'style': 'solid' },
    'rProject': { 'icon': 'r-project', 'style': 'brands' },
    'radiation': { 'icon': 'radiation', 'style': 'solid' },
    'radiationAlt': { 'icon': 'radiation-alt', 'style': 'solid' },
    'rainbow': { 'icon': 'rainbow', 'style': 'solid' },
    'random': { 'icon': 'random', 'style': 'solid' },
    'raspberryPi': { 'icon': 'raspberry-pi', 'style': 'brands' },
    'ravelry': { 'icon': 'ravelry', 'style': 'brands' },
    'react': { 'icon': 'react', 'style': 'brands' },
    'reacteurope': { 'icon': 'reacteurope', 'style': 'brands' },
    'readme': { 'icon': 'readme', 'style': 'brands' },
    'rebel': { 'icon': 'rebel', 'style': 'brands' },
    'receipt': { 'icon': 'receipt', 'style': 'solid' },
    'recordVinyl': { 'icon': 'record-vinyl', 'style': 'solid' },
    'recycle': { 'icon': 'recycle', 'style': 'solid' },
    'redRiver': { 'icon': 'red-river', 'style': 'brands' },
    'reddit': { 'icon': 'reddit', 'style': 'brands' },
    'redditAlien': { 'icon': 'reddit-alien', 'style': 'brands' },
    'redditSquare': { 'icon': 'reddit-square', 'style': 'brands' },
    'redhat': { 'icon': 'redhat', 'style': 'brands' },
    'redo': { 'icon': 'redo', 'style': 'solid' },
    'redoAlt': { 'icon': 'redo-alt', 'style': 'solid' },
    'registered': { 'icon': 'registered', 'style': 'regular' },
    'solidRegistered': { 'icon': 'registered', 'style': 'solid' },
    'removeFormat': { 'icon': 'remove-format', 'style': 'solid' },
    'renren': { 'icon': 'renren', 'style': 'brands' },
    'reply': { 'icon': 'reply', 'style': 'solid' },
    'replyAll': { 'icon': 'reply-all', 'style': 'solid' },
    'replyd': { 'icon': 'replyd', 'style': 'brands' },
    'republican': { 'icon': 'republican', 'style': 'solid' },
    'researchgate': { 'icon': 'researchgate', 'style': 'brands' },
    'resolving': { 'icon': 'resolving', 'style': 'brands' },
    'restroom': { 'icon': 'restroom', 'style': 'solid' },
    'retweet': { 'icon': 'retweet', 'style': 'solid' },
    'rev': { 'icon': 'rev', 'style': 'brands' },
    'ribbon': { 'icon': 'ribbon', 'style': 'solid' },
    'ring': { 'icon': 'ring', 'style': 'solid' },
    'road': { 'icon': 'road', 'style': 'solid' },
    'robot': { 'icon': 'robot', 'style': 'solid' },
    'rocket': { 'icon': 'rocket', 'style': 'solid' },
    'rocketchat': { 'icon': 'rocketchat', 'style': 'brands' },
    'rockrms': { 'icon': 'rockrms', 'style': 'brands' },
    'route': { 'icon': 'route', 'style': 'solid' },
    'rss': { 'icon': 'rss', 'style': 'solid' },
    'rssSquare': { 'icon': 'rss-square', 'style': 'solid' },
    'rubleSign': { 'icon': 'ruble-sign', 'style': 'solid' },
    'ruler': { 'icon': 'ruler', 'style': 'solid' },
    'rulerCombined': { 'icon': 'ruler-combined', 'style': 'solid' },
    'rulerHorizontal': { 'icon': 'ruler-horizontal', 'style': 'solid' },
    'rulerVertical': { 'icon': 'ruler-vertical', 'style': 'solid' },
    'running': { 'icon': 'running', 'style': 'solid' },
    'rupeeSign': { 'icon': 'rupee-sign', 'style': 'solid' },
    'rust': { 'icon': 'rust', 'style': 'brands' },
    'sadCry': { 'icon': 'sad-cry', 'style': 'regular' },
    'solidSadCry': { 'icon': 'sad-cry', 'style': 'solid' },
    'sadTear': { 'icon': 'sad-tear', 'style': 'regular' },
    'solidSadTear': { 'icon': 'sad-tear', 'style': 'solid' },
    'safari': { 'icon': 'safari', 'style': 'brands' },
    'salesforce': { 'icon': 'salesforce', 'style': 'brands' },
    'sass': { 'icon': 'sass', 'style': 'brands' },
    'satellite': { 'icon': 'satellite', 'style': 'solid' },
    'satelliteDish': { 'icon': 'satellite-dish', 'style': 'solid' },
    'save': { 'icon': 'save', 'style': 'regular' },
    'solidSave': { 'icon': 'save', 'style': 'solid' },
    'schlix': { 'icon': 'schlix', 'style': 'brands' },
    'school': { 'icon': 'school', 'style': 'solid' },
    'screwdriver': { 'icon': 'screwdriver', 'style': 'solid' },
    'scribd': { 'icon': 'scribd', 'style': 'brands' },
    'scroll': { 'icon': 'scroll', 'style': 'solid' },
    'sdCard': { 'icon': 'sd-card', 'style': 'solid' },
    'search': { 'icon': 'search', 'style': 'solid' },
    'searchDollar': { 'icon': 'search-dollar', 'style': 'solid' },
    'searchLocation': { 'icon': 'search-location', 'style': 'solid' },
    'searchMinus': { 'icon': 'search-minus', 'style': 'solid' },
    'searchPlus': { 'icon': 'search-plus', 'style': 'solid' },
    'searchengin': { 'icon': 'searchengin', 'style': 'brands' },
    'seedling': { 'icon': 'seedling', 'style': 'solid' },
    'sellcast': { 'icon': 'sellcast', 'style': 'brands' },
    'sellsy': { 'icon': 'sellsy', 'style': 'brands' },
    'server': { 'icon': 'server', 'style': 'solid' },
    'servicestack': { 'icon': 'servicestack', 'style': 'brands' },
    'shapes': { 'icon': 'shapes', 'style': 'solid' },
    'share': { 'icon': 'share', 'style': 'solid' },
    'shareAlt': { 'icon': 'share-alt', 'style': 'solid' },
    'shareAltSquare': { 'icon': 'share-alt-square', 'style': 'solid' },
    'shareSquare': { 'icon': 'share-square', 'style': 'regular' },
    'solidShareSquare': { 'icon': 'share-square', 'style': 'solid' },
    'shekelSign': { 'icon': 'shekel-sign', 'style': 'solid' },
    'shieldAlt': { 'icon': 'shield-alt', 'style': 'solid' },
    'shieldVirus': { 'icon': 'shield-virus', 'style': 'solid' },
    'ship': { 'icon': 'ship', 'style': 'solid' },
    'shippingFast': { 'icon': 'shipping-fast', 'style': 'solid' },
    'shirtsinbulk': { 'icon': 'shirtsinbulk', 'style': 'brands' },
    'shoePrints': { 'icon': 'shoe-prints', 'style': 'solid' },
    'shopify': { 'icon': 'shopify', 'style': 'brands' },
    'shoppingBag': { 'icon': 'shopping-bag', 'style': 'solid' },
    'shoppingBasket': { 'icon': 'shopping-basket', 'style': 'solid' },
    'shoppingCart': { 'icon': 'shopping-cart', 'style': 'solid' },
    'shopware': { 'icon': 'shopware', 'style': 'brands' },
    'shower': { 'icon': 'shower', 'style': 'solid' },
    'shuttleVan': { 'icon': 'shuttle-van', 'style': 'solid' },
    'sign': { 'icon': 'sign', 'style': 'solid' },
    'signInAlt': { 'icon': 'sign-in-alt', 'style': 'solid' },
    'signLanguage': { 'icon': 'sign-language', 'style': 'solid' },
    'signOutAlt': { 'icon': 'sign-out-alt', 'style': 'solid' },
    'signal': { 'icon': 'signal', 'style': 'solid' },
    'signature': { 'icon': 'signature', 'style': 'solid' },
    'simCard': { 'icon': 'sim-card', 'style': 'solid' },
    'simplybuilt': { 'icon': 'simplybuilt', 'style': 'brands' },
    'sink': { 'icon': 'sink', 'style': 'solid' },
    'sistrix': { 'icon': 'sistrix', 'style': 'brands' },
    'sitemap': { 'icon': 'sitemap', 'style': 'solid' },
    'sith': { 'icon': 'sith', 'style': 'brands' },
    'skating': { 'icon': 'skating', 'style': 'solid' },
    'sketch': { 'icon': 'sketch', 'style': 'brands' },
    'skiing': { 'icon': 'skiing', 'style': 'solid' },
    'skiingNordic': { 'icon': 'skiing-nordic', 'style': 'solid' },
    'skull': { 'icon': 'skull', 'style': 'solid' },
    'skullCrossbones': { 'icon': 'skull-crossbones', 'style': 'solid' },
    'skyatlas': { 'icon': 'skyatlas', 'style': 'brands' },
    'skype': { 'icon': 'skype', 'style': 'brands' },
    'slack': { 'icon': 'slack', 'style': 'brands' },
    'slackHash': { 'icon': 'slack-hash', 'style': 'brands' },
    'slash': { 'icon': 'slash', 'style': 'solid' },
    'sleigh': { 'icon': 'sleigh', 'style': 'solid' },
    'slidersH': { 'icon': 'sliders-h', 'style': 'solid' },
    'slideshare': { 'icon': 'slideshare', 'style': 'brands' },
    'smile': { 'icon': 'smile', 'style': 'regular' },
    'solidSmile': { 'icon': 'smile', 'style': 'solid' },
    'smileBeam': { 'icon': 'smile-beam', 'style': 'regular' },
    'solidSmileBeam': { 'icon': 'smile-beam', 'style': 'solid' },
    'smileWink': { 'icon': 'smile-wink', 'style': 'regular' },
    'solidSmileWink': { 'icon': 'smile-wink', 'style': 'solid' },
    'smog': { 'icon': 'smog', 'style': 'solid' },
    'smoking': { 'icon': 'smoking', 'style': 'solid' },
    'smokingBan': { 'icon': 'smoking-ban', 'style': 'solid' },
    'sms': { 'icon': 'sms', 'style': 'solid' },
    'snapchat': { 'icon': 'snapchat', 'style': 'brands' },
    'snapchatGhost': { 'icon': 'snapchat-ghost', 'style': 'brands' },
    'snapchatSquare': { 'icon': 'snapchat-square', 'style': 'brands' },
    'snowboarding': { 'icon': 'snowboarding', 'style': 'solid' },
    'snowflake': { 'icon': 'snowflake', 'style': 'regular' },
    'solidSnowflake': { 'icon': 'snowflake', 'style': 'solid' },
    'snowman': { 'icon': 'snowman', 'style': 'solid' },
    'snowplow': { 'icon': 'snowplow', 'style': 'solid' },
    'soap': { 'icon': 'soap', 'style': 'solid' },
    'socks': { 'icon': 'socks', 'style': 'solid' },
    'solarPanel': { 'icon': 'solar-panel', 'style': 'solid' },
    'sort': { 'icon': 'sort', 'style': 'solid' },
    'sortAlphaDown': { 'icon': 'sort-alpha-down', 'style': 'solid' },
    'sortAlphaDownAlt': { 'icon': 'sort-alpha-down-alt', 'style': 'solid' },
    'sortAlphaUp': { 'icon': 'sort-alpha-up', 'style': 'solid' },
    'sortAlphaUpAlt': { 'icon': 'sort-alpha-up-alt', 'style': 'solid' },
    'sortAmountDown': { 'icon': 'sort-amount-down', 'style': 'solid' },
    'sortAmountDownAlt': { 'icon': 'sort-amount-down-alt', 'style': 'solid' },
    'sortAmountUp': { 'icon': 'sort-amount-up', 'style': 'solid' },
    'sortAmountUpAlt': { 'icon': 'sort-amount-up-alt', 'style': 'solid' },
    'sortDown': { 'icon': 'sort-down', 'style': 'solid' },
    'sortNumericDown': { 'icon': 'sort-numeric-down', 'style': 'solid' },
    'sortNumericDownAlt': { 'icon': 'sort-numeric-down-alt', 'style': 'solid' },
    'sortNumericUp': { 'icon': 'sort-numeric-up', 'style': 'solid' },
    'sortNumericUpAlt': { 'icon': 'sort-numeric-up-alt', 'style': 'solid' },
    'sortUp': { 'icon': 'sort-up', 'style': 'solid' },
    'soundcloud': { 'icon': 'soundcloud', 'style': 'brands' },
    'sourcetree': { 'icon': 'sourcetree', 'style': 'brands' },
    'spa': { 'icon': 'spa', 'style': 'solid' },
    'spaceShuttle': { 'icon': 'space-shuttle', 'style': 'solid' },
    'speakap': { 'icon': 'speakap', 'style': 'brands' },
    'speakerDeck': { 'icon': 'speaker-deck', 'style': 'brands' },
    'spellCheck': { 'icon': 'spell-check', 'style': 'solid' },
    'spider': { 'icon': 'spider', 'style': 'solid' },
    'spinner': { 'icon': 'spinner', 'style': 'solid' },
    'splotch': { 'icon': 'splotch', 'style': 'solid' },
    'spotify': { 'icon': 'spotify', 'style': 'brands' },
    'sprayCan': { 'icon': 'spray-can', 'style': 'solid' },
    'square': { 'icon': 'square', 'style': 'regular' },
    'solidSquare': { 'icon': 'square', 'style': 'solid' },
    'squareFull': { 'icon': 'square-full', 'style': 'solid' },
    'squareRootAlt': { 'icon': 'square-root-alt', 'style': 'solid' },
    'squarespace': { 'icon': 'squarespace', 'style': 'brands' },
    'stackExchange': { 'icon': 'stack-exchange', 'style': 'brands' },
    'stackOverflow': { 'icon': 'stack-overflow', 'style': 'brands' },
    'stackpath': { 'icon': 'stackpath', 'style': 'brands' },
    'stamp': { 'icon': 'stamp', 'style': 'solid' },
    'star': { 'icon': 'star', 'style': 'regular' },
    'solidStar': { 'icon': 'star', 'style': 'solid' },
    'starAndCrescent': { 'icon': 'star-and-crescent', 'style': 'solid' },
    'starHalf': { 'icon': 'star-half', 'style': 'regular' },
    'solidStarHalf': { 'icon': 'star-half', 'style': 'solid' },
    'starHalfAlt': { 'icon': 'star-half-alt', 'style': 'solid' },
    'starOfDavid': { 'icon': 'star-of-david', 'style': 'solid' },
    'starOfLife': { 'icon': 'star-of-life', 'style': 'solid' },
    'staylinked': { 'icon': 'staylinked', 'style': 'brands' },
    'steam': { 'icon': 'steam', 'style': 'brands' },
    'steamSquare': { 'icon': 'steam-square', 'style': 'brands' },
    'steamSymbol': { 'icon': 'steam-symbol', 'style': 'brands' },
    'stepBackward': { 'icon': 'step-backward', 'style': 'solid' },
    'stepForward': { 'icon': 'step-forward', 'style': 'solid' },
    'stethoscope': { 'icon': 'stethoscope', 'style': 'solid' },
    'stickerMule': { 'icon': 'sticker-mule', 'style': 'brands' },
    'stickyNote': { 'icon': 'sticky-note', 'style': 'regular' },
    'solidStickyNote': { 'icon': 'sticky-note', 'style': 'solid' },
    'stop': { 'icon': 'stop', 'style': 'solid' },
    'stopCircle': { 'icon': 'stop-circle', 'style': 'regular' },
    'solidStopCircle': { 'icon': 'stop-circle', 'style': 'solid' },
    'stopwatch': { 'icon': 'stopwatch', 'style': 'solid' },
    'stopwatch20': { 'icon': 'stopwatch-20', 'style': 'solid' },
    'store': { 'icon': 'store', 'style': 'solid' },
    'storeAlt': { 'icon': 'store-alt', 'style': 'solid' },
    'storeAltSlash': { 'icon': 'store-alt-slash', 'style': 'solid' },
    'storeSlash': { 'icon': 'store-slash', 'style': 'solid' },
    'strava': { 'icon': 'strava', 'style': 'brands' },
    'stream': { 'icon': 'stream', 'style': 'solid' },
    'streetView': { 'icon': 'street-view', 'style': 'solid' },
    'strikethrough': { 'icon': 'strikethrough', 'style': 'solid' },
    'stripe': { 'icon': 'stripe', 'style': 'brands' },
    'stripeS': { 'icon': 'stripe-s', 'style': 'brands' },
    'stroopwafel': { 'icon': 'stroopwafel', 'style': 'solid' },
    'studiovinari': { 'icon': 'studiovinari', 'style': 'brands' },
    'stumbleupon': { 'icon': 'stumbleupon', 'style': 'brands' },
    'stumbleuponCircle': { 'icon': 'stumbleupon-circle', 'style': 'brands' },
    'subscript': { 'icon': 'subscript', 'style': 'solid' },
    'subway': { 'icon': 'subway', 'style': 'solid' },
    'suitcase': { 'icon': 'suitcase', 'style': 'solid' },
    'suitcaseRolling': { 'icon': 'suitcase-rolling', 'style': 'solid' },
    'sun': { 'icon': 'sun', 'style': 'regular' },
    'solidSun': { 'icon': 'sun', 'style': 'solid' },
    'superpowers': { 'icon': 'superpowers', 'style': 'brands' },
    'superscript': { 'icon': 'superscript', 'style': 'solid' },
    'supple': { 'icon': 'supple', 'style': 'brands' },
    'surprise': { 'icon': 'surprise', 'style': 'regular' },
    'solidSurprise': { 'icon': 'surprise', 'style': 'solid' },
    'suse': { 'icon': 'suse', 'style': 'brands' },
    'swatchbook': { 'icon': 'swatchbook', 'style': 'solid' },
    'swift': { 'icon': 'swift', 'style': 'brands' },
    'swimmer': { 'icon': 'swimmer', 'style': 'solid' },
    'swimmingPool': { 'icon': 'swimming-pool', 'style': 'solid' },
    'symfony': { 'icon': 'symfony', 'style': 'brands' },
    'synagogue': { 'icon': 'synagogue', 'style': 'solid' },
    'sync': { 'icon': 'sync', 'style': 'solid' },
    'syncAlt': { 'icon': 'sync-alt', 'style': 'solid' },
    'syringe': { 'icon': 'syringe', 'style': 'solid' },
    'table': { 'icon': 'table', 'style': 'solid' },
    'tableTennis': { 'icon': 'table-tennis', 'style': 'solid' },
    'tablet': { 'icon': 'tablet', 'style': 'solid' },
    'tabletAlt': { 'icon': 'tablet-alt', 'style': 'solid' },
    'tablets': { 'icon': 'tablets', 'style': 'solid' },
    'tachometerAlt': { 'icon': 'tachometer-alt', 'style': 'solid' },
    'tag': { 'icon': 'tag', 'style': 'solid' },
    'tags': { 'icon': 'tags', 'style': 'solid' },
    'tape': { 'icon': 'tape', 'style': 'solid' },
    'tasks': { 'icon': 'tasks', 'style': 'solid' },
    'taxi': { 'icon': 'taxi', 'style': 'solid' },
    'teamspeak': { 'icon': 'teamspeak', 'style': 'brands' },
    'teeth': { 'icon': 'teeth', 'style': 'solid' },
    'teethOpen': { 'icon': 'teeth-open', 'style': 'solid' },
    'telegram': { 'icon': 'telegram', 'style': 'brands' },
    'telegramPlane': { 'icon': 'telegram-plane', 'style': 'brands' },
    'temperatureHigh': { 'icon': 'temperature-high', 'style': 'solid' },
    'temperatureLow': { 'icon': 'temperature-low', 'style': 'solid' },
    'tencentWeibo': { 'icon': 'tencent-weibo', 'style': 'brands' },
    'tenge': { 'icon': 'tenge', 'style': 'solid' },
    'terminal': { 'icon': 'terminal', 'style': 'solid' },
    'textHeight': { 'icon': 'text-height', 'style': 'solid' },
    'textWidth': { 'icon': 'text-width', 'style': 'solid' },
    'thLarge': { 'icon': 'th-large', 'style': 'solid' },
    'thList': { 'icon': 'th-list', 'style': 'solid' },
    'theRedYeti': { 'icon': 'the-red-yeti', 'style': 'brands' },
    'theaterMasks': { 'icon': 'theater-masks', 'style': 'solid' },
    'themeco': { 'icon': 'themeco', 'style': 'brands' },
    'themeisle': { 'icon': 'themeisle', 'style': 'brands' },
    'thermometer': { 'icon': 'thermometer', 'style': 'solid' },
    'thermometerEmpty': { 'icon': 'thermometer-empty', 'style': 'solid' },
    'thermometerFull': { 'icon': 'thermometer-full', 'style': 'solid' },
    'thermometerHalf': { 'icon': 'thermometer-half', 'style': 'solid' },
    'thermometerQuarter': { 'icon': 'thermometer-quarter', 'style': 'solid' },
    'thermometerThreeQuarters': { 'icon': 'thermometer-three-quarters', 'style': 'solid' },
    'thinkPeaks': { 'icon': 'think-peaks', 'style': 'brands' },
    'thumbsDown': { 'icon': 'thumbs-down', 'style': 'regular' },
    'solidThumbsDown': { 'icon': 'thumbs-down', 'style': 'solid' },
    'thumbsUp': { 'icon': 'thumbs-up', 'style': 'regular' },
    'solidThumbsUp': { 'icon': 'thumbs-up', 'style': 'solid' },
    'thumbtack': { 'icon': 'thumbtack', 'style': 'solid' },
    'ticketAlt': { 'icon': 'ticket-alt', 'style': 'solid' },
    'tiktok': { 'icon': 'tiktok', 'style': 'brands' },
    'times': { 'icon': 'times', 'style': 'solid' },
    'timesCircle': { 'icon': 'times-circle', 'style': 'regular' },
    'solidTimesCircle': { 'icon': 'times-circle', 'style': 'solid' },
    'tint': { 'icon': 'tint', 'style': 'solid' },
    'tintSlash': { 'icon': 'tint-slash', 'style': 'solid' },
    'tired': { 'icon': 'tired', 'style': 'regular' },
    'solidTired': { 'icon': 'tired', 'style': 'solid' },
    'toggleOff': { 'icon': 'toggle-off', 'style': 'solid' },
    'toggleOn': { 'icon': 'toggle-on', 'style': 'solid' },
    'toilet': { 'icon': 'toilet', 'style': 'solid' },
    'toiletPaper': { 'icon': 'toilet-paper', 'style': 'solid' },
    'toiletPaperSlash': { 'icon': 'toilet-paper-slash', 'style': 'solid' },
    'toolbox': { 'icon': 'toolbox', 'style': 'solid' },
    'tools': { 'icon': 'tools', 'style': 'solid' },
    'tooth': { 'icon': 'tooth', 'style': 'solid' },
    'torah': { 'icon': 'torah', 'style': 'solid' },
    'toriiGate': { 'icon': 'torii-gate', 'style': 'solid' },
    'tractor': { 'icon': 'tractor', 'style': 'solid' },
    'tradeFederation': { 'icon': 'trade-federation', 'style': 'brands' },
    'trademark': { 'icon': 'trademark', 'style': 'solid' },
    'trafficLight': { 'icon': 'traffic-light', 'style': 'solid' },
    'trailer': { 'icon': 'trailer', 'style': 'solid' },
    'train': { 'icon': 'train', 'style': 'solid' },
    'tram': { 'icon': 'tram', 'style': 'solid' },
    'transgender': { 'icon': 'transgender', 'style': 'solid' },
    'transgenderAlt': { 'icon': 'transgender-alt', 'style': 'solid' },
    'trash': { 'icon': 'trash', 'style': 'solid' },
    'trashAlt': { 'icon': 'trash-alt', 'style': 'regular' },
    'solidTrashAlt': { 'icon': 'trash-alt', 'style': 'solid' },
    'trashRestore': { 'icon': 'trash-restore', 'style': 'solid' },
    'trashRestoreAlt': { 'icon': 'trash-restore-alt', 'style': 'solid' },
    'tree': { 'icon': 'tree', 'style': 'solid' },
    'trello': { 'icon': 'trello', 'style': 'brands' },
    'tripadvisor': { 'icon': 'tripadvisor', 'style': 'brands' },
    'trophy': { 'icon': 'trophy', 'style': 'solid' },
    'truck': { 'icon': 'truck', 'style': 'solid' },
    'truckLoading': { 'icon': 'truck-loading', 'style': 'solid' },
    'truckMonster': { 'icon': 'truck-monster', 'style': 'solid' },
    'truckMoving': { 'icon': 'truck-moving', 'style': 'solid' },
    'truckPickup': { 'icon': 'truck-pickup', 'style': 'solid' },
    'tshirt': { 'icon': 'tshirt', 'style': 'solid' },
    'tty': { 'icon': 'tty', 'style': 'solid' },
    'tumblr': { 'icon': 'tumblr', 'style': 'brands' },
    'tumblrSquare': { 'icon': 'tumblr-square', 'style': 'brands' },
    'twitch': { 'icon': 'twitch', 'style': 'brands' },
    'twitter': { 'icon': 'twitter', 'style': 'brands' },
    'twitterSquare': { 'icon': 'twitter-square', 'style': 'brands' },
    'typo3': { 'icon': 'typo3', 'style': 'brands' },
    'uber': { 'icon': 'uber', 'style': 'brands' },
    'ubuntu': { 'icon': 'ubuntu', 'style': 'brands' },
    'uikit': { 'icon': 'uikit', 'style': 'brands' },
    'umbraco': { 'icon': 'umbraco', 'style': 'brands' },
    'umbrella': { 'icon': 'umbrella', 'style': 'solid' },
    'umbrellaBeach': { 'icon': 'umbrella-beach', 'style': 'solid' },
    'uncharted': { 'icon': 'uncharted', 'style': 'brands' },
    'underline': { 'icon': 'underline', 'style': 'solid' },
    'undo': { 'icon': 'undo', 'style': 'solid' },
    'undoAlt': { 'icon': 'undo-alt', 'style': 'solid' },
    'uniregistry': { 'icon': 'uniregistry', 'style': 'brands' },
    'unity': { 'icon': 'unity', 'style': 'brands' },
    'universalAccess': { 'icon': 'universal-access', 'style': 'solid' },
    'university': { 'icon': 'university', 'style': 'solid' },
    'unlink': { 'icon': 'unlink', 'style': 'solid' },
    'unlock': { 'icon': 'unlock', 'style': 'solid' },
    'unlockAlt': { 'icon': 'unlock-alt', 'style': 'solid' },
    'unsplash': { 'icon': 'unsplash', 'style': 'brands' },
    'untappd': { 'icon': 'untappd', 'style': 'brands' },
    'upload': { 'icon': 'upload', 'style': 'solid' },
    'ups': { 'icon': 'ups', 'style': 'brands' },
    'usb': { 'icon': 'usb', 'style': 'brands' },
    'user': { 'icon': 'user', 'style': 'regular' },
    'solidUser': { 'icon': 'user', 'style': 'solid' },
    'userAlt': { 'icon': 'user-alt', 'style': 'solid' },
    'userAltSlash': { 'icon': 'user-alt-slash', 'style': 'solid' },
    'userAstronaut': { 'icon': 'user-astronaut', 'style': 'solid' },
    'userCheck': { 'icon': 'user-check', 'style': 'solid' },
    'userCircle': { 'icon': 'user-circle', 'style': 'regular' },
    'solidUserCircle': { 'icon': 'user-circle', 'style': 'solid' },
    'userClock': { 'icon': 'user-clock', 'style': 'solid' },
    'userCog': { 'icon': 'user-cog', 'style': 'solid' },
    'userEdit': { 'icon': 'user-edit', 'style': 'solid' },
    'userFriends': { 'icon': 'user-friends', 'style': 'solid' },
    'userGraduate': { 'icon': 'user-graduate', 'style': 'solid' },
    'userInjured': { 'icon': 'user-injured', 'style': 'solid' },
    'userLock': { 'icon': 'user-lock', 'style': 'solid' },
    'userMd': { 'icon': 'user-md', 'style': 'solid' },
    'userMinus': { 'icon': 'user-minus', 'style': 'solid' },
    'userNinja': { 'icon': 'user-ninja', 'style': 'solid' },
    'userNurse': { 'icon': 'user-nurse', 'style': 'solid' },
    'userPlus': { 'icon': 'user-plus', 'style': 'solid' },
    'userSecret': { 'icon': 'user-secret', 'style': 'solid' },
    'userShield': { 'icon': 'user-shield', 'style': 'solid' },
    'userSlash': { 'icon': 'user-slash', 'style': 'solid' },
    'userTag': { 'icon': 'user-tag', 'style': 'solid' },
    'userTie': { 'icon': 'user-tie', 'style': 'solid' },
    'userTimes': { 'icon': 'user-times', 'style': 'solid' },
    'users': { 'icon': 'users', 'style': 'solid' },
    'usersCog': { 'icon': 'users-cog', 'style': 'solid' },
    'usersSlash': { 'icon': 'users-slash', 'style': 'solid' },
    'usps': { 'icon': 'usps', 'style': 'brands' },
    'ussunnah': { 'icon': 'ussunnah', 'style': 'brands' },
    'utensilSpoon': { 'icon': 'utensil-spoon', 'style': 'solid' },
    'utensils': { 'icon': 'utensils', 'style': 'solid' },
    'vaadin': { 'icon': 'vaadin', 'style': 'brands' },
    'vectorSquare': { 'icon': 'vector-square', 'style': 'solid' },
    'venus': { 'icon': 'venus', 'style': 'solid' },
    'venusDouble': { 'icon': 'venus-double', 'style': 'solid' },
    'venusMars': { 'icon': 'venus-mars', 'style': 'solid' },
    'vest': { 'icon': 'vest', 'style': 'solid' },
    'vestPatches': { 'icon': 'vest-patches', 'style': 'solid' },
    'viacoin': { 'icon': 'viacoin', 'style': 'brands' },
    'viadeo': { 'icon': 'viadeo', 'style': 'brands' },
    'viadeoSquare': { 'icon': 'viadeo-square', 'style': 'brands' },
    'vial': { 'icon': 'vial', 'style': 'solid' },
    'vials': { 'icon': 'vials', 'style': 'solid' },
    'viber': { 'icon': 'viber', 'style': 'brands' },
    'video': { 'icon': 'video', 'style': 'solid' },
    'videoSlash': { 'icon': 'video-slash', 'style': 'solid' },
    'vihara': { 'icon': 'vihara', 'style': 'solid' },
    'vimeo': { 'icon': 'vimeo', 'style': 'brands' },
    'vimeoSquare': { 'icon': 'vimeo-square', 'style': 'brands' },
    'vimeoV': { 'icon': 'vimeo-v', 'style': 'brands' },
    'vine': { 'icon': 'vine', 'style': 'brands' },
    'virus': { 'icon': 'virus', 'style': 'solid' },
    'virusSlash': { 'icon': 'virus-slash', 'style': 'solid' },
    'viruses': { 'icon': 'viruses', 'style': 'solid' },
    'vnv': { 'icon': 'vnv', 'style': 'brands' },
    'voicemail': { 'icon': 'voicemail', 'style': 'solid' },
    'volleyballBall': { 'icon': 'volleyball-ball', 'style': 'solid' },
    'volumeDown': { 'icon': 'volume-down', 'style': 'solid' },
    'volumeMute': { 'icon': 'volume-mute', 'style': 'solid' },
    'volumeOff': { 'icon': 'volume-off', 'style': 'solid' },
    'volumeUp': { 'icon': 'volume-up', 'style': 'solid' },
    'voteYea': { 'icon': 'vote-yea', 'style': 'solid' },
    'vrCardboard': { 'icon': 'vr-cardboard', 'style': 'solid' },
    'vuejs': { 'icon': 'vuejs', 'style': 'brands' },
    'walking': { 'icon': 'walking', 'style': 'solid' },
    'wallet': { 'icon': 'wallet', 'style': 'solid' },
    'warehouse': { 'icon': 'warehouse', 'style': 'solid' },
    'watchmanMonitoring': { 'icon': 'watchman-monitoring', 'style': 'brands' },
    'water': { 'icon': 'water', 'style': 'solid' },
    'waveSquare': { 'icon': 'wave-square', 'style': 'solid' },
    'waze': { 'icon': 'waze', 'style': 'brands' },
    'weebly': { 'icon': 'weebly', 'style': 'brands' },
    'weibo': { 'icon': 'weibo', 'style': 'brands' },
    'weight': { 'icon': 'weight', 'style': 'solid' },
    'weightHanging': { 'icon': 'weight-hanging', 'style': 'solid' },
    'weixin': { 'icon': 'weixin', 'style': 'brands' },
    'whatsapp': { 'icon': 'whatsapp', 'style': 'brands' },
    'whatsappSquare': { 'icon': 'whatsapp-square', 'style': 'brands' },
    'wheelchair': { 'icon': 'wheelchair', 'style': 'solid' },
    'whmcs': { 'icon': 'whmcs', 'style': 'brands' },
    'wifi': { 'icon': 'wifi', 'style': 'solid' },
    'wikipediaW': { 'icon': 'wikipedia-w', 'style': 'brands' },
    'wind': { 'icon': 'wind', 'style': 'solid' },
    'windowClose': { 'icon': 'window-close', 'style': 'regular' },
    'solidWindowClose': { 'icon': 'window-close', 'style': 'solid' },
    'windowMaximize': { 'icon': 'window-maximize', 'style': 'regular' },
    'solidWindowMaximize': { 'icon': 'window-maximize', 'style': 'solid' },
    'windowMinimize': { 'icon': 'window-minimize', 'style': 'regular' },
    'solidWindowMinimize': { 'icon': 'window-minimize', 'style': 'solid' },
    'windowRestore': { 'icon': 'window-restore', 'style': 'regular' },
    'solidWindowRestore': { 'icon': 'window-restore', 'style': 'solid' },
    'windows': { 'icon': 'windows', 'style': 'brands' },
    'wineBottle': { 'icon': 'wine-bottle', 'style': 'solid' },
    'wineGlass': { 'icon': 'wine-glass', 'style': 'solid' },
    'wineGlassAlt': { 'icon': 'wine-glass-alt', 'style': 'solid' },
    'wix': { 'icon': 'wix', 'style': 'brands' },
    'wizardsOfTheCoast': { 'icon': 'wizards-of-the-coast', 'style': 'brands' },
    'wodu': { 'icon': 'wodu', 'style': 'brands' },
    'wolfPackBattalion': { 'icon': 'wolf-pack-battalion', 'style': 'brands' },
    'wonSign': { 'icon': 'won-sign', 'style': 'solid' },
    'wordpress': { 'icon': 'wordpress', 'style': 'brands' },
    'wordpressSimple': { 'icon': 'wordpress-simple', 'style': 'brands' },
    'wpbeginner': { 'icon': 'wpbeginner', 'style': 'brands' },
    'wpexplorer': { 'icon': 'wpexplorer', 'style': 'brands' },
    'wpforms': { 'icon': 'wpforms', 'style': 'brands' },
    'wpressr': { 'icon': 'wpressr', 'style': 'brands' },
    'wrench': { 'icon': 'wrench', 'style': 'solid' },
    'xRay': { 'icon': 'x-ray', 'style': 'solid' },
    'xbox': { 'icon': 'xbox', 'style': 'brands' },
    'xing': { 'icon': 'xing', 'style': 'brands' },
    'xingSquare': { 'icon': 'xing-square', 'style': 'brands' },
    'yCombinator': { 'icon': 'y-combinator', 'style': 'brands' },
    'yahoo': { 'icon': 'yahoo', 'style': 'brands' },
    'yammer': { 'icon': 'yammer', 'style': 'brands' },
    'yandex': { 'icon': 'yandex', 'style': 'brands' },
    'yandexInternational': { 'icon': 'yandex-international', 'style': 'brands' },
    'yarn': { 'icon': 'yarn', 'style': 'brands' },
    'yelp': { 'icon': 'yelp', 'style': 'brands' },
    'yenSign': { 'icon': 'yen-sign', 'style': 'solid' },
    'yinYang': { 'icon': 'yin-yang', 'style': 'solid' },
    'yoast': { 'icon': 'yoast', 'style': 'brands' },
    'youtube': { 'icon': 'youtube', 'style': 'brands' },
    'youtubeSquare': { 'icon': 'youtube-square', 'style': 'brands' },
    'zhihu': { 'icon': 'zhihu', 'style': 'brands' },
    'ad': { 'icon': 'ad', 'style': 'solid' },
    'at': { 'icon': 'at', 'style': 'solid' },
    'gg': { 'icon': 'gg', 'style': 'brands' },
    'js': { 'icon': 'js', 'style': 'brands' },
    'om': { 'icon': 'om', 'style': 'solid' },
    'qq': { 'icon': 'qq', 'style': 'brands' },
    'th': { 'icon': 'th', 'style': 'solid' },
    'tv': { 'icon': 'tv', 'style': 'solid' },
    'vk': { 'icon': 'vk', 'style': 'brands' },

    // removed in fontawesome 6 it seems 
    'acquisitionsIncorporated': { 'icon': 'acquisitions-incorporated', 'style': 'brands' },
    'pennyArcade': { 'icon': 'penny-arcade', 'style': 'brands' },
};
export default Icons;